// AUTO-GENERATED from Dart layout files — do not edit manually
// Usage: Object.assign(F15AddNewThemeForm.prototype, LayoutMethods);

class CollageInfo {
    constructor() {
        this._isRight = false;
        this._left = 0;
        this._top = 0;
        this._width = 0;
        this._height = 0;
    }
    setIsRight(value) { this._isRight = value; }
    setLeft(value) { this._left = value; }
    setTop(value) { this._top = value; }
    setWidth(value) { this._width = value; }
    setHeight(value) { this._height = value; }
    getIsRight() { return this._isRight; }
    getLeft() { return this._left; }
    getTop() { return this._top; }
    getWidth() { return this._width; }
    getHeight() { return this._height; }
}

const LayoutMethods = {

    ml_125({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(639 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2179 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },

    ml_126({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2714 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },

    ml_127({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(596 / exportHeight);
        collageInfo1
            .setWidth(((2603 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_128({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(596 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_129({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((792 + addition) / exportWidth);
        collageInfo1.setTop(623 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2177 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_130({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((554 + addition) / exportWidth);
        collageInfo1.setTop(425 / exportHeight);
        collageInfo1
            .setWidth(((2896 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1974 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_131({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((329 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((2520 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2175 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_132({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((255 + addition) / exportWidth);
        collageInfo1.setTop(155 / exportHeight);
        collageInfo1
            .setWidth(((3241 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2235 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_133({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1608 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_134({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1907 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2098 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_135({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((905 + addition) / exportWidth);
        collageInfo1.setTop(596 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_136({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((793 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_137({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(623 / exportHeight);
        collageInfo1
            .setWidth(((2714 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2177 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_138({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1601 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2098 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_139({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((583 + addition) / exportWidth);
        collageInfo1.setTop(264 / exportHeight);
        collageInfo1
            .setWidth(((2925 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1608 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_140({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1004 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((2504 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2250 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_141({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((554 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2954 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_142({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1008 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3207 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_143({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2207 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2108 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_144({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(488 / exportHeight);
        collageInfo1
            .setWidth(((2529 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1911 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_145({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((2250 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2175 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_146({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((977 + addition) / exportWidth);
        collageInfo1.setTop(488 / exportHeight);
        collageInfo1
            .setWidth(((3518 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1911 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_147({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(315 / exportHeight);
        collageInfo1
            .setWidth(((3145 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2084 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_148({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((361 + addition) / exportWidth);
        collageInfo1.setTop(611 / exportHeight);
        collageInfo1
            .setWidth(((3136 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2172 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_149({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((3506 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2025 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_150({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((585 + addition) / exportWidth);
        collageInfo1.setTop(750 / exportHeight);
        collageInfo1
            .setWidth(((2685 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2250 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_151({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_152({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1748 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((3181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2031 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_154({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((322 + addition) / exportWidth);
        collageInfo1.setTop(205 / exportHeight);
        collageInfo1
            .setWidth(((3184 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1815 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_155({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((322 + addition) / exportWidth);
        collageInfo1.setTop(395 / exportHeight);
        collageInfo1
            .setWidth(((3184 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2010 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_156fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((3506 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2700 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_157fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(280 / exportHeight);
        collageInfo1
            .setWidth(((3506 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2045 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_158fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((585 + addition) / exportWidth);
        collageInfo1.setTop(395 / exportHeight);
        collageInfo1
            .setWidth(((2685 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1925 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_159fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((351 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((3135 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2185 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_160fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(970 / exportHeight);
        collageInfo1
            .setWidth(((3506 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2725 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_161ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((666) / exportWidth);
        collageInfo1.setTop(640 / exportHeight);
        collageInfo1.setWidth(((3365) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2358 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_162({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1079 + addition) / exportWidth);
        collageInfo1.setTop(525 / exportHeight);
        collageInfo1
            .setWidth(((2427 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1875 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_163fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((888 + addition) / exportWidth); // 890 - 2
        image1.setTop(600 / exportHeight); // 603 - 3
        image1.setWidth(
            ((2683 + addition) / exportWidth) - image1.getLeft()); // 2678 + 5
        image1.setHeight((2393 / exportHeight) - image1.getTop()); // 2391 + 2
        image1.isCircle = true;
        collageInfoList.push(image1);
        return collageInfoList;

    },
    ml_163({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((322 + addition) / exportWidth);
        collageInfo1.setTop(205 / exportHeight);
        collageInfo1
            .setWidth(((3184 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1815 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((322 + addition) / exportWidth);
        collageInfo2.setTop(1863 / exportHeight);
        collageInfo2
            .setWidth(((3184 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2179 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    ml_164({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((328 + addition) / exportWidth);
        collageInfo1.setTop(297 / exportHeight);
        collageInfo1
            .setWidth(((1702 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2103 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1744 + addition) / exportWidth);
        collageInfo2.setTop(297 / exportHeight);
        collageInfo2
            .setWidth(((3178 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2103 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    ml_165({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1608 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((322 + addition) / exportWidth);
        collageInfo2.setTop(1657 / exportHeight);
        collageInfo2
            .setWidth(((3184 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1974 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    ml_201({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((387 + addition) / exportWidth);
        collageInfo1.setTop(618 / exportHeight);
        collageInfo1
            .setWidth(((1736 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2216 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1770 + addition) / exportWidth);
        collageInfo2.setTop(618 / exportHeight);
        collageInfo2
            .setWidth(((3120 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2216 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_202({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((705 + addition) / exportWidth);
        collageInfo1.setTop(676 / exportHeight);
        collageInfo1
            .setWidth(((2037 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2073 + addition) / exportWidth);
        collageInfo2.setTop(371 / exportHeight);
        collageInfo2
            .setWidth(((3506 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_203({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(454 / exportHeight);
        collageInfo1
            .setWidth(((1506 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1543 + addition) / exportWidth);
        collageInfo2.setTop(454 / exportHeight);
        collageInfo2
            .setWidth(((3048 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_204({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1735 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((0 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((1735 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_205({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((386 + addition) / exportWidth);
        collageInfo1.setTop(803 / exportHeight);
        collageInfo1
            .setWidth(((1724 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2174 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1782 + addition) / exportWidth);
        collageInfo2.setTop(803 / exportHeight);
        collageInfo2
            .setWidth(((3120 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2174 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_206({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((466 + addition) / exportWidth);
        collageInfo1.setTop(627 / exportHeight);
        collageInfo1
            .setWidth(((1726 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1998 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1780 + addition) / exportWidth);
        collageInfo2.setTop(627 / exportHeight);
        collageInfo2
            .setWidth(((3040 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1998 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_207({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((240 + addition) / exportWidth);
        collageInfo1.setTop(203 / exportHeight);
        collageInfo1
            .setWidth(((1744 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2122 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(827 / exportHeight);
        collageInfo2
            .setWidth(((3256 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2122 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_208({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((359 + addition) / exportWidth);
        collageInfo1.setTop(234 / exportHeight);
        collageInfo1
            .setWidth(((1744 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2165 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(234 / exportHeight);
        collageInfo2
            .setWidth(((3157 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2165 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_209({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((1725 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2099 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1763 + addition) / exportWidth);
        collageInfo2.setTop(300 / exportHeight);
        collageInfo2
            .setWidth(((3508 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2099 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_210({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((328 + addition) / exportWidth);
        collageInfo1.setTop(232 / exportHeight);
        collageInfo1
            .setWidth(((2279 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1789 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2324 + addition) / exportWidth);
        collageInfo2.setTop(229 / exportHeight);
        collageInfo2
            .setWidth(((3178 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1783 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_211({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1772 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((3508 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_212({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((459 + addition) / exportWidth);
        collageInfo1.setTop(454 / exportHeight);
        collageInfo1
            .setWidth(((1964 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2001 + addition) / exportWidth);
        collageInfo2.setTop(454 / exportHeight);
        collageInfo2
            .setWidth(((3508 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_213({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((250 + addition) / exportWidth);
        collageInfo1.setTop(827 / exportHeight);
        collageInfo1
            .setWidth(((1734 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2122 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(203 / exportHeight);
        collageInfo2
            .setWidth(((3256 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2122 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_214({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(371 / exportHeight);
        collageInfo1
            .setWidth(((1433 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1469 + addition) / exportWidth);
        collageInfo2.setTop(676 / exportHeight);
        collageInfo2
            .setWidth(((2801 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_215({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((570 + addition) / exportWidth);
        collageInfo1.setTop(314 / exportHeight);
        collageInfo1
            .setWidth(((1744 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2085 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1767 + addition) / exportWidth);
        collageInfo2.setTop(542 / exportHeight);
        collageInfo2
            .setWidth(((2936 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1847 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_216({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1846 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1546 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((300 + addition) / exportWidth);
        collageInfo2.setTop(1589 / exportHeight);
        collageInfo2
            .setWidth(((1846 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_217({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2453 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1449 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((300 + addition) / exportWidth);
        collageInfo2.setTop(1477 / exportHeight);
        collageInfo2
            .setWidth(((1266 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2099 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_218({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((0 + addition) / exportWidth);
        collageInfo2.setTop(1199 / exportHeight);
        collageInfo2
            .setWidth(((1754 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2174 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1754 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1199 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    ml_219({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1732 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1911 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1774 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((3508 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1911 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_220({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1739 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3508 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1451 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1739 + addition) / exportWidth);
        collageInfo2.setTop(1488 / exportHeight);
        collageInfo2
            .setWidth(((3508 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_221({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((312 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((1734 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1657 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(225 / exportHeight);
        collageInfo2
            .setWidth(((3194 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1657 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_222fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1
            .setWidth(((1729 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2067 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(false);
        collageInfo2.setLeft((1767) / exportWidth);
        collageInfo2.setTop(450 / exportHeight);
        collageInfo2.setWidth(((3496) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2067 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    ml_223ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((520) / exportWidth);
        collageInfo1.setTop(961 / exportHeight);
        collageInfo1.setWidth(((1997) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2038 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(false);
        collageInfo2.setLeft((2034) / exportWidth);
        collageInfo2.setTop(961 / exportHeight);
        collageInfo2.setWidth(((3511) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2038 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    ml_224({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const offsetPos = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1768 + offsetPos) / exportWidth);
        image1.setTop(239 / exportHeight);
        image1.setWidth(((3253 + offsetPos) / exportWidth) - image1.getLeft());
        image1.setHeight((1185 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1768 + offsetPos) / exportWidth);
        image2.setTop(1215 / exportHeight);
        image2.setWidth(((3253 + offsetPos) / exportWidth) - image2.getLeft());
        image2.setHeight((2160 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        return collageInfoList;

    },
    ml_225({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const offsetPos = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((272 + offsetPos) / exportWidth);
        image1.setTop(463 / exportHeight);
        image1.setWidth(((1756 + offsetPos) / exportWidth) - image1.getLeft());
        image1.setHeight((1409 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1792 + offsetPos) / exportWidth);
        image2.setTop(463 / exportHeight);
        image2.setWidth(((3277 + offsetPos) / exportWidth) - image2.getLeft());
        image2.setHeight((1409 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        return collageInfoList;

    },
    ml_226({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((270 + addition) / exportWidth);
        collageInfo1.setTop(254 / exportHeight);
        collageInfo1
            .setWidth(((3236 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((721 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((270 + addition) / exportWidth);
        collageInfo2.setTop(774 / exportHeight);
        collageInfo2
            .setWidth(((1722 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2146 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1784 + addition) / exportWidth);
        collageInfo3.setTop(774 / exportHeight);
        collageInfo3
            .setWidth(((3236 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2146 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_227({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((329 + addition) / exportWidth);
        collageInfo1.setTop(229 / exportHeight);
        collageInfo1
            .setWidth(((2280 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1655 / exportHeight) - collageInfo1.getTop());

        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2324 + addition) / exportWidth);
        collageInfo2.setTop(229 / exportHeight);
        collageInfo2
            .setWidth(((3179 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1655 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((329 + addition) / exportWidth);
        collageInfo3.setTop(1709 / exportHeight);
        collageInfo3
            .setWidth(((3179 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2175 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_228({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((311 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((1734 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1648 / exportHeight) - collageInfo1.getTop());

        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(225 / exportHeight);
        collageInfo2
            .setWidth(((3195 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1648 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((311 + addition) / exportWidth);
        collageInfo3.setTop(1709 / exportHeight);
        collageInfo3
            .setWidth(((3195 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2175 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_301({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2302 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1845 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2337 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((3508 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((903 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2337 + addition) / exportWidth);
        collageInfo3.setTop(942 / exportHeight);
        collageInfo3
            .setWidth(((3508 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1845 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_302({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((328 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((2262 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2174 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2338 + addition) / exportWidth);
        collageInfo2.setTop(225 / exportHeight);
        collageInfo2
            .setWidth(((3178 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1158 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2338 + addition) / exportWidth);
        collageInfo3.setTop(1242 / exportHeight);
        collageInfo3
            .setWidth(((3178 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2174 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_303({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((394 + addition) / exportWidth);
        collageInfo1.setTop(225 / exportHeight);
        collageInfo1
            .setWidth(((1894 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2174 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1932 + addition) / exportWidth);
        collageInfo2.setTop(225 / exportHeight);
        collageInfo2
            .setWidth(((3188 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((855 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1932 + addition) / exportWidth);
        collageInfo3.setTop(893 / exportHeight);
        collageInfo3
            .setWidth(((3188 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2174 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_304({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((404 + addition) / exportWidth);
        collageInfo1.setTop(142 / exportHeight);
        collageInfo1
            .setWidth(((1377 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1022 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((404 + addition) / exportWidth);
        collageInfo2.setTop(1060 / exportHeight);
        collageInfo2
            .setWidth(((1377 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1940 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1415 + addition) / exportWidth);
        collageInfo3.setTop(142 / exportHeight);
        collageInfo3
            .setWidth(((3103 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1940 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_305({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((253 + addition) / exportWidth);
        collageInfo1.setTop(237 / exportHeight);
        collageInfo1
            .setWidth(((1738 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1182 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1768 + addition) / exportWidth);
        collageInfo2.setTop(237 / exportHeight);
        collageInfo2
            .setWidth(((3253 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1182 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1768 + addition) / exportWidth);
        collageInfo3.setTop(1217 / exportHeight);
        collageInfo3
            .setWidth(((3253 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2162 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_306({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((278 + addition) / exportWidth);
        collageInfo1.setTop(154 / exportHeight);
        collageInfo1
            .setWidth(((1734 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((834 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(154 / exportHeight);
        collageInfo2
            .setWidth(((3228 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((834 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((278 + addition) / exportWidth);
        collageInfo3.setTop(868 / exportHeight);
        collageInfo3
            .setWidth(((3228 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1894 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_307({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((380 + addition) / exportWidth);
        collageInfo1.setTop(269 / exportHeight);
        collageInfo1
            .setWidth(((1273 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1619 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1307 + addition) / exportWidth);
        collageInfo2.setTop(269 / exportHeight);
        collageInfo2
            .setWidth(((2200 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1619 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2234 + addition) / exportWidth);
        collageInfo3.setTop(269 / exportHeight);
        collageInfo3
            .setWidth(((3127 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1619 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_308({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((743 + addition) / exportWidth);
        collageInfo1.setTop(292 / exportHeight);
        collageInfo1
            .setWidth(((1736 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1475 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((743 + addition) / exportWidth);
        collageInfo2.setTop(1509 / exportHeight);
        collageInfo2
            .setWidth(((1736 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2108 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1771 + addition) / exportWidth);
        collageInfo3.setTop(292 / exportHeight);
        collageInfo3
            .setWidth(((2764 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2108 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ml_309({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1427 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((881 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(881 / exportHeight);
        image2.setWidth(((1427 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1763 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1427 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1763 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ml_310({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((515 + addition) / exportWidth);
        image1.setTop(227 / exportHeight);
        image1.setWidth(((1406 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((889 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1443 + addition) / exportWidth);
        image2.setTop(227 / exportHeight);
        image2.setWidth(((2992 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((889 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((515 + addition) / exportWidth);
        image3.setTop(927 / exportHeight);
        image3.setWidth(((2992 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2172 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ml_311({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1632 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((3206 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((781 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1632 + addition) / exportWidth);
        image2.setTop(809 / exportHeight);
        image2.setWidth(((3206 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1590 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1632 + addition) / exportWidth);
        image3.setTop(1618 / exportHeight);
        image3.setWidth(((3206 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ml_312({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((419 + addition) / exportWidth);
        image1.setTop(536 / exportHeight);
        image1.setWidth(((1477 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1373 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1514 + addition) / exportWidth);
        image2.setTop(277 / exportHeight);
        image2.setWidth(((3088 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1373 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((419 + addition) / exportWidth);
        image3.setTop(1407 / exportHeight);
        image3.setWidth(((1477 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2122 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ml_313({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(277 / exportHeight);
        image1.setWidth(((1169 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1744 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1169 + addition) / exportWidth);
        image2.setTop(277 / exportHeight);
        image2.setWidth(((2338 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1744 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2338 + addition) / exportWidth);
        image3.setTop(277 / exportHeight);
        image3.setWidth(((3518 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1744 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ml_314({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((253 + addition) / exportWidth);
        collageInfo1.setTop(237 / exportHeight);
        collageInfo1
            .setWidth(((1738 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1183 / exportHeight) - collageInfo1.getTop());

        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1768 + addition) / exportWidth);
        collageInfo2.setTop(237 / exportHeight);
        collageInfo2
            .setWidth(((3253 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1183 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((253 + addition) / exportWidth);
        collageInfo3.setTop(1217 / exportHeight);
        collageInfo3
            .setWidth(((1738 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2163 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1768 + addition) / exportWidth);
        collageInfo4.setTop(1217 / exportHeight);
        collageInfo4
            .setWidth(((3253 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2163 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ml_315({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((380 + addition) / exportWidth);
        collageInfo1.setTop(269 / exportHeight);
        collageInfo1
            .setWidth(((1273 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1619 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1307 + addition) / exportWidth);
        collageInfo2.setTop(269 / exportHeight);
        collageInfo2
            .setWidth(((2200 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1619 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2234 + addition) / exportWidth);
        collageInfo3.setTop(269 / exportHeight);
        collageInfo3
            .setWidth(((3127 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1619 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((380 + addition) / exportWidth);
        collageInfo4.setTop(1670 / exportHeight);
        collageInfo4
            .setWidth(((3127 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2136 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ml_316({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((418 + addition) / exportWidth);
        collageInfo1.setTop(536 / exportHeight);
        collageInfo1
            .setWidth(((1477 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1373 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1514 + addition) / exportWidth);
        collageInfo2.setTop(277 / exportHeight);
        collageInfo2
            .setWidth(((3089 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1373 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((418 + addition) / exportWidth);
        collageInfo3.setTop(1407 / exportHeight);
        collageInfo3
            .setWidth(((1477 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2123 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1514 + addition) / exportWidth);
        collageInfo4.setTop(1407 / exportHeight);
        collageInfo4
            .setWidth(((3089 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2123 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ml_401({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((412 + addition) / exportWidth);
        image1.setTop(508 / exportHeight);
        image1.setWidth(((1701 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1310 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((412 + addition) / exportWidth);
        image2.setTop(1418 / exportHeight);
        image2.setWidth(((1701 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2220 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1805 + addition) / exportWidth);
        image3.setTop(508 / exportHeight);
        image3.setWidth(((3094 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1310 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1805 + addition) / exportWidth);
        image4.setTop(1418 / exportHeight);
        image4.setWidth(((3094 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2220 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_402({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((328 + addition) / exportWidth);
        image1.setTop(224 / exportHeight);
        image1.setWidth(((1724 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1169 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((328 + addition) / exportWidth);
        image2.setTop(1231 / exportHeight);
        image2.setWidth(((1724 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2176 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1782 + addition) / exportWidth);
        image3.setTop(224 / exportHeight);
        image3.setWidth(((3178 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1169 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1782 + addition) / exportWidth);
        image4.setTop(1231 / exportHeight);
        image4.setWidth(((3178 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2176 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_403({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((253 + addition) / exportWidth);
        image1.setTop(328 / exportHeight);
        image1.setWidth(((1737 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1371 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((253 + addition) / exportWidth);
        image2.setTop(1404 / exportHeight);
        image2.setWidth(((1737 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2072 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1769 + addition) / exportWidth);
        image3.setTop(328 / exportHeight);
        image3.setWidth(((3253 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((996 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1769 + addition) / exportWidth);
        image4.setTop(1029 / exportHeight);
        image4.setWidth(((3253 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2072 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_404({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1735 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(1218 / exportHeight);
        image2.setWidth(((1735 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2400 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1772 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1181 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1772 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((3508 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2400 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_405({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((253 + addition) / exportWidth);
        image1.setTop(328 / exportHeight);
        image1.setWidth(((1737 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1183 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1769 + addition) / exportWidth);
        image2.setTop(328 / exportHeight);
        image2.setWidth(((3253 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1183 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((253 + addition) / exportWidth);
        image3.setTop(1216 / exportHeight);
        image3.setWidth(((1737 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2072 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1769 + addition) / exportWidth);
        image4.setTop(1216 / exportHeight);
        image4.setWidth(((3253 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2072 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_406({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((328 + addition) / exportWidth);
        image1.setTop(225 / exportHeight);
        image1.setWidth(((1214 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1171 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1276 + addition) / exportWidth);
        image2.setTop(225 / exportHeight);
        image2.setWidth(((3178 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1171 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((328 + addition) / exportWidth);
        image3.setTop(1229 / exportHeight);
        image3.setWidth(((2230 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2174 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2292 + addition) / exportWidth);
        image4.setTop(1229 / exportHeight);
        image4.setWidth(((3178 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2174 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_407({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((328 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1732 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1775 + addition) / exportWidth);
        image2.setTop(225 / exportHeight);
        image2.setWidth(((3178 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((328 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1732 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2099 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1775 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((3178 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2099 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_408({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((329 + addition) / exportWidth);
        image1.setTop(225 / exportHeight);
        image1.setWidth(((2230 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1171 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2293 + addition) / exportWidth);
        image2.setTop(225 / exportHeight);
        image2.setWidth(((3178 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1171 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((329 + addition) / exportWidth);
        image3.setTop(1229 / exportHeight);
        image3.setWidth(((1214 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2174 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1277 + addition) / exportWidth);
        image4.setTop(1229 / exportHeight);
        image4.setWidth(((3178 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2174 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_409({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1137 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1175 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2312 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1137 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1175 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2312 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2399 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_410({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((332 + addition) / exportWidth);
        image1.setTop(171 / exportHeight);
        image1.setWidth(((1734 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((962 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1772 + addition) / exportWidth);
        image2.setTop(171 / exportHeight);
        image2.setWidth(((3174 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((962 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((332 + addition) / exportWidth);
        image3.setTop(1438 / exportHeight);
        image3.setWidth(((1734 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2229 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1772 + addition) / exportWidth);
        image4.setTop(1438 / exportHeight);
        image4.setWidth(((3184 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2229 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_411({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((487 + addition) / exportWidth);
        image1.setTop(112 / exportHeight);
        image1.setWidth(((3019 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1472 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((487 + addition) / exportWidth);
        image2.setTop(1592 / exportHeight);
        image2.setWidth(((1235 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2287 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1379 + addition) / exportWidth);
        image3.setTop(1592 / exportHeight);
        image3.setWidth(((2127 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2287 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2271 + addition) / exportWidth);
        image4.setTop(1592 / exportHeight);
        image4.setWidth(((3019 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2287 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_412({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1737 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((921 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1775 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3508 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1451 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(958 / exportHeight);
        image3.setWidth(((1737 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1775 + addition) / exportWidth);
        image4.setTop(1488 / exportHeight);
        image4.setWidth(((3508 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2400 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_413({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(224 / exportHeight);
        image1.setWidth(((1201 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1238 + addition) / exportWidth);
        image2.setTop(224 / exportHeight);
        image2.setWidth(((2439 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1201 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2175 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1238 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2439 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2175 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_414({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((861 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((2173 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((847 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2211 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3508 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1516 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((861 + addition) / exportWidth);
        image3.setTop(884 / exportHeight);
        image3.setWidth(((2173 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2211 + addition) / exportWidth);
        image4.setTop(1554 / exportHeight);
        image4.setWidth(((3508 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2400 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_415ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((636) / exportWidth);
        collageInfo1.setTop(584 / exportHeight);
        collageInfo1.setWidth(((1997) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1481 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(false);
        collageInfo2.setLeft((2034) / exportWidth);
        collageInfo2.setTop(584 / exportHeight);
        collageInfo2.setWidth(((3395) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1481 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(false);
        collageInfo3.setLeft((636) / exportWidth);
        collageInfo3.setTop(1518 / exportHeight);
        collageInfo3.setWidth(((1997) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2406 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(false);
        collageInfo4.setLeft((2034) / exportWidth);
        collageInfo4.setTop(1518 / exportHeight);
        collageInfo4.setWidth(((3395) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2406 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ml_416({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1754 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((882 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1754 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3508 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((882 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(882 / exportHeight);
        image3.setWidth(((1754 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1763 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1754 + addition) / exportWidth);
        image4.setTop(882 / exportHeight);
        image4.setWidth(((3508 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1763 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ml_417({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((217 + addition) / exportWidth);
        collageInfo1.setTop(296 / exportHeight);
        collageInfo1
            .setWidth(((3289 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((696 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((217 + addition) / exportWidth);
        collageInfo2.setTop(763 / exportHeight);
        collageInfo2
            .setWidth(((963 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2184 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((992 + addition) / exportWidth);
        collageInfo3.setTop(763 / exportHeight);
        collageInfo3
            .setWidth(((1738 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2184 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1768 + addition) / exportWidth);
        collageInfo4.setTop(763 / exportHeight);
        collageInfo4
            .setWidth(((2514 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2184 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        const collageInfo5 = new CollageInfo();
        collageInfo5.setIsRight(isRightPage);
        collageInfo5.setLeft((2543 + addition) / exportWidth);
        collageInfo5.setTop(763 / exportHeight);
        collageInfo5
            .setWidth(((3289 + addition) / exportWidth) - collageInfo5.getLeft());
        collageInfo5.setHeight((2184 / exportHeight) - collageInfo5.getTop());
        collageInfoList.push(collageInfo5);

        return collageInfoList;

    },
    ml_418({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4010 : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((332 + addition) / exportWidth);
        collageInfo1.setTop(171 / exportHeight);
        collageInfo1
            .setWidth(((1734 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((962 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1772 + addition) / exportWidth);
        collageInfo2.setTop(171 / exportHeight);
        collageInfo2
            .setWidth(((3174 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((962 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((332 + addition) / exportWidth);
        collageInfo3.setTop(1000 / exportHeight);
        collageInfo3
            .setWidth(((3174 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1400 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((332 + addition) / exportWidth);
        collageInfo4.setTop(1438 / exportHeight);
        collageInfo4
            .setWidth(((1734 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2229 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        const collageInfo5 = new CollageInfo();
        collageInfo5.setIsRight(isRightPage);
        collageInfo5.setLeft((1772 + addition) / exportWidth);
        collageInfo5.setTop(1438 / exportHeight);
        collageInfo5
            .setWidth(((2174 + addition) / exportWidth) - collageInfo5.getLeft());
        collageInfo5.setHeight((2229 / exportHeight) - collageInfo5.getTop());
        collageInfoList.push(collageInfo5);

        return collageInfoList;

    },
    ml_501({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(276 / exportHeight);
        image1.setWidth(((2219 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1361 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2262 + addition) / exportWidth);
        image2.setTop(276 / exportHeight);
        image2.setWidth(((3206 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1361 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1408 / exportHeight);
        image3.setWidth(((1238 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2099 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1283 + addition) / exportWidth);
        image4.setTop(1408 / exportHeight);
        image4.setWidth(((2222 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2099 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2267 + addition) / exportWidth);
        image5.setTop(1408 / exportHeight);
        image5.setWidth(((3206 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2099 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_502({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1322 + addition) / exportWidth);
        image1.setTop(107 / exportHeight);
        image1.setWidth(((2241 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((985 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1322 + addition) / exportWidth);
        image2.setTop(1045 / exportHeight);
        image2.setWidth(((2241 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2279 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2288 + addition) / exportWidth);
        image3.setTop(107 / exportHeight);
        image3.setWidth(((3206 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((807 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2288 + addition) / exportWidth);
        image4.setTop(843 / exportHeight);
        image4.setWidth(((3206 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1543 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2288 + addition) / exportWidth);
        image5.setTop(1579 / exportHeight);
        image5.setWidth(((3206 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2279 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_503({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1769 + addition) / exportWidth);
        image1.setTop(72 / exportHeight);
        image1.setWidth(((3436 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((860 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1769 + addition) / exportWidth);
        image2.setTop(909 / exportHeight);
        image2.setWidth(((2583 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1488 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2635 + addition) / exportWidth);
        image3.setTop(909 / exportHeight);
        image3.setWidth(((3436 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1488 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1769 + addition) / exportWidth);
        image4.setTop(1537 / exportHeight);
        image4.setWidth(((2583 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2325 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2635 + addition) / exportWidth);
        image5.setTop(1537 / exportHeight);
        image5.setWidth(((3436 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2325 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_504({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((760 + addition) / exportWidth);
        image1.setTop(233 / exportHeight);
        image1.setWidth(((1769 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((894 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1806 + addition) / exportWidth);
        image2.setTop(371 / exportHeight);
        image2.setWidth(((2558 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((897 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((586 + addition) / exportWidth);
        image3.setTop(934 / exportHeight);
        image3.setWidth(((1769 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1565 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1806 + addition) / exportWidth);
        image4.setTop(934 / exportHeight);
        image4.setWidth(((2921 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2049 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((892 + addition) / exportWidth);
        image5.setTop(1602 / exportHeight);
        image5.setWidth(((1769 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2167 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_505({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((315 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1254 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1291 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2216 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2099 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2253 + addition) / exportWidth);
        image3.setTop(300 / exportHeight);
        image3.setWidth(((3192 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1181 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((315 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((1254 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2099 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2253 + addition) / exportWidth);
        image5.setTop(1218 / exportHeight);
        image5.setWidth(((3192 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2099 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_506({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((326 + addition) / exportWidth);
        image1.setTop(304 / exportHeight);
        image1.setWidth(((1572 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2095 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1609 + addition) / exportWidth);
        image2.setTop(304 / exportHeight);
        image2.setWidth(((2377 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2414 + addition) / exportWidth);
        image3.setTop(304 / exportHeight);
        image3.setWidth(((3181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1181 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1609 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2377 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2095 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2414 + addition) / exportWidth);
        image5.setTop(1218 / exportHeight);
        image5.setWidth(((3181 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2095 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_507({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((768 + addition) / exportWidth);
        image1.setTop(265 / exportHeight);
        image1.setWidth(((1735 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1499 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((768 + addition) / exportWidth);
        image2.setTop(1536 / exportHeight);
        image2.setWidth(((1735 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2135 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1772 + addition) / exportWidth);
        image3.setTop(265 / exportHeight);
        image3.setWidth(((2739 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((863 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1772 + addition) / exportWidth);
        image4.setTop(901 / exportHeight);
        image4.setWidth(((2739 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1499 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1772 + addition) / exportWidth);
        image5.setTop(1536 / exportHeight);
        image5.setWidth(((2739 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2135 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_508({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1754 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((774 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(813 / exportHeight);
        image2.setWidth(((1754 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1587 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1626 / exportHeight);
        image3.setWidth(((1754 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1791 + addition) / exportWidth);
        image4.setTop(0 / exportHeight);
        image4.setWidth(((3508 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1346 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1791 + addition) / exportWidth);
        image5.setTop(1391 / exportHeight);
        image5.setWidth(((3508 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2400 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ml_601({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((866 + addition) / exportWidth);
        image1.setTop(234 / exportHeight);
        image1.setWidth(((1616 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1178 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1661 + addition) / exportWidth);
        image2.setTop(234 / exportHeight);
        image2.setWidth(((2411 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1178 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2456 + addition) / exportWidth);
        image3.setTop(234 / exportHeight);
        image3.setWidth(((3206 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1178 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((866 + addition) / exportWidth);
        image4.setTop(1222 / exportHeight);
        image4.setWidth(((1616 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2165 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1661 + addition) / exportWidth);
        image5.setTop(1222 / exportHeight);
        image5.setWidth(((2411 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2165 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2456 + addition) / exportWidth);
        image6.setTop(1222 / exportHeight);
        image6.setWidth(((3206 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2165 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_602({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((484 + addition) / exportWidth);
        image1.setTop(265 / exportHeight);
        image1.setWidth(((1403 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1185 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1435 + addition) / exportWidth);
        image2.setTop(265 / exportHeight);
        image2.setWidth(((2069 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((868 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2103 + addition) / exportWidth);
        image3.setTop(265 / exportHeight);
        image3.setWidth(((3022 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1185 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((484 + addition) / exportWidth);
        image4.setTop(1215 / exportHeight);
        image4.setWidth(((1403 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2134 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1435 + addition) / exportWidth);
        image5.setTop(897 / exportHeight);
        image5.setWidth(((2069 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2134 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2103 + addition) / exportWidth);
        image6.setTop(1215 / exportHeight);
        image6.setWidth(((3022 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2134 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_603({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((550 + addition) / exportWidth);
        image1.setTop(417 / exportHeight);
        image1.setWidth(((1333 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1183 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1362 + addition) / exportWidth);
        image2.setTop(417 / exportHeight);
        image2.setWidth(((2145 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1183 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2174 + addition) / exportWidth);
        image3.setTop(417 / exportHeight);
        image3.setWidth(((2957 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1183 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((550 + addition) / exportWidth);
        image4.setTop(1216 / exportHeight);
        image4.setWidth(((1333 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1983 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1362 + addition) / exportWidth);
        image5.setTop(1216 / exportHeight);
        image5.setWidth(((2145 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1983 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2174 + addition) / exportWidth);
        image6.setTop(1216 / exportHeight);
        image6.setWidth(((2957 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1983 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_604({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1163 + addition) / exportWidth);
        image1.setTop(161 / exportHeight);
        image1.setWidth(((2496 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((831 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2533 + addition) / exportWidth);
        image2.setTop(161 / exportHeight);
        image2.setWidth(((3283 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((831 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((691 + addition) / exportWidth);
        image3.setTop(865 / exportHeight);
        image3.setWidth(((2024 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1535 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2062 + addition) / exportWidth);
        image4.setTop(865 / exportHeight);
        image4.setWidth(((2811 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1535 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((223 + addition) / exportWidth);
        image5.setTop(1568 / exportHeight);
        image5.setWidth(((1556 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2239 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1594 + addition) / exportWidth);
        image6.setTop(1568 / exportHeight);
        image6.setWidth(((2343 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2239 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_605({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1894 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((2569 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2606 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((3281 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1894 + addition) / exportWidth);
        image3.setTop(862 / exportHeight);
        image3.setWidth(((2569 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1537 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2606 + addition) / exportWidth);
        image4.setTop(862 / exportHeight);
        image4.setWidth(((3281 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1537 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1894 + addition) / exportWidth);
        image5.setTop(1575 / exportHeight);
        image5.setWidth(((2569 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2606 + addition) / exportWidth);
        image6.setTop(1575 / exportHeight);
        image6.setWidth(((3281 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_606({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((529 + addition) / exportWidth);
        image1.setTop(311 / exportHeight);
        image1.setWidth(((1358 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1140 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1473 + addition) / exportWidth);
        image2.setTop(303 / exportHeight);
        image2.setWidth(((2031 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((830 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2141 + addition) / exportWidth);
        image3.setTop(303 / exportHeight);
        image3.setWidth(((2985 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1147 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((529 + addition) / exportWidth);
        image4.setTop(1257 / exportHeight);
        image4.setWidth(((1358 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2087 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1473 + addition) / exportWidth);
        image5.setTop(939 / exportHeight);
        image5.setWidth(((2031 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2093 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2141 + addition) / exportWidth);
        image6.setTop(1256 / exportHeight);
        image6.setWidth(((2985 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2093 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_607({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((331 + addition) / exportWidth);
        image1.setTop(275 / exportHeight);
        image1.setWidth(((1183 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1137 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1322 + addition) / exportWidth);
        image2.setTop(275 / exportHeight);
        image2.setWidth(((2173 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1137 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2313 + addition) / exportWidth);
        image3.setTop(275 / exportHeight);
        image3.setWidth(((3165 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1137 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((331 + addition) / exportWidth);
        image4.setTop(1262 / exportHeight);
        image4.setWidth(((1183 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2125 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1322 + addition) / exportWidth);
        image5.setTop(1262 / exportHeight);
        image5.setWidth(((2173 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2125 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2313 + addition) / exportWidth);
        image6.setTop(1262 / exportHeight);
        image6.setWidth(((3165 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2125 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_608({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1144 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((892 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1181 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2325 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((892 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2362 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((892 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1507 / exportHeight);
        image4.setWidth(((1144 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2399 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1181 + addition) / exportWidth);
        image5.setTop(1507 / exportHeight);
        image5.setWidth(((2325 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2399 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2362 + addition) / exportWidth);
        image6.setTop(1507 / exportHeight);
        image6.setWidth(((3508 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2399 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_609({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((236 + addition) / exportWidth);
        image1.setTop(185 / exportHeight);
        image1.setWidth(((1379 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((860 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1416 + addition) / exportWidth);
        image2.setTop(185 / exportHeight);
        image2.setWidth(((2091 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((860 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2128 + addition) / exportWidth);
        image3.setTop(185 / exportHeight);
        image3.setWidth(((3271 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((860 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((236 + addition) / exportWidth);
        image4.setTop(1539 / exportHeight);
        image4.setWidth(((1379 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2214 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1416 + addition) / exportWidth);
        image5.setTop(1539 / exportHeight);
        image5.setWidth(((2091 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2214 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2128 + addition) / exportWidth);
        image6.setTop(1539 / exportHeight);
        image6.setWidth(((3271 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2214 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_610({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(540 / exportHeight);
        image1.setWidth(((1145 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1377 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1181 + addition) / exportWidth);
        image2.setTop(540 / exportHeight);
        image2.setWidth(((2326 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1377 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2362 + addition) / exportWidth);
        image3.setTop(540 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1377 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1414 / exportHeight);
        image4.setWidth(((1145 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2252 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1181 + addition) / exportWidth);
        image5.setTop(1414 / exportHeight);
        image5.setWidth(((2326 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2252 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2362 + addition) / exportWidth);
        image6.setTop(1414 / exportHeight);
        image6.setWidth(((3508 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2252 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_611({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(260 / exportHeight);
        image1.setWidth(((1145 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1122 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1181 + addition) / exportWidth);
        image2.setTop(260 / exportHeight);
        image2.setWidth(((2326 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1122 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2362 + addition) / exportWidth);
        image3.setTop(260 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1122 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1348 / exportHeight);
        image4.setWidth(((1145 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2211 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1181 + addition) / exportWidth);
        image5.setTop(1348 / exportHeight);
        image5.setWidth(((2326 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2211 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2362 + addition) / exportWidth);
        image6.setTop(1348 / exportHeight);
        image6.setWidth(((3508 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2211 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_612({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((634 + addition) / exportWidth);
        image1.setTop(252 / exportHeight);
        image1.setWidth(((1330 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((948 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1405 + addition) / exportWidth);
        image2.setTop(252 / exportHeight);
        image2.setWidth(((2102 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((948 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2177 + addition) / exportWidth);
        image3.setTop(252 / exportHeight);
        image3.setWidth(((2873 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((948 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((634 + addition) / exportWidth);
        image4.setTop(1451 / exportHeight);
        image4.setWidth(((1330 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2147 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1405 + addition) / exportWidth);
        image5.setTop(1451 / exportHeight);
        image5.setWidth(((2102 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2147 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2177 + addition) / exportWidth);
        image6.setTop(1451 / exportHeight);
        image6.setWidth(((2873 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2147 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_613({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((592 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1735 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1772 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2915 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((592 + addition) / exportWidth);
        image3.setTop(862 / exportHeight);
        image3.setWidth(((1735 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1537 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1772 + addition) / exportWidth);
        image4.setTop(862 / exportHeight);
        image4.setWidth(((2915 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1537 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((592 + addition) / exportWidth);
        image5.setTop(1575 / exportHeight);
        image5.setWidth(((1735 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1772 + addition) / exportWidth);
        image6.setTop(1575 / exportHeight);
        image6.setWidth(((2915 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_614({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1146 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((899 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1181 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2326 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1463 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2361 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((899 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(937 / exportHeight);
        image4.setWidth(((1146 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2400 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1181 + addition) / exportWidth);
        image5.setTop(1500 / exportHeight);
        image5.setWidth(((2326 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2400 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2361 + addition) / exportWidth);
        image6.setTop(937 / exportHeight);
        image6.setWidth(((3508 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2400 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ml_701({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((169 + addition) / exportWidth);
        image1.setTop(112 / exportHeight);
        image1.setWidth(((1883 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1543 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1936 + addition) / exportWidth);
        image2.setTop(112 / exportHeight);
        image2.setWidth(((2603 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((683 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2669 + addition) / exportWidth);
        image3.setTop(112 / exportHeight);
        image3.setWidth(((3337 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((683 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1936 + addition) / exportWidth);
        image4.setTop(732 / exportHeight);
        image4.setWidth(((3337 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1543 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((169 + addition) / exportWidth);
        image5.setTop(1592 / exportHeight);
        image5.setWidth(((1348 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2287 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1402 + addition) / exportWidth);
        image6.setTop(1592 / exportHeight);
        image6.setWidth(((2581 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2287 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((2642 + addition) / exportWidth);
        image7.setTop(1592 / exportHeight);
        image7.setWidth(((3337 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2287 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    ml_702({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((2330 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((918 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2367 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3508 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((918 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(955 / exportHeight);
        image3.setWidth(((1145 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1452 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1184 + addition) / exportWidth);
        image4.setTop(955 / exportHeight);
        image4.setWidth(((2330 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1452 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2367 + addition) / exportWidth);
        image5.setTop(955 / exportHeight);
        image5.setWidth(((3508 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1452 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(1489 / exportHeight);
        image6.setWidth(((1145 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2400 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1184 + addition) / exportWidth);
        image7.setTop(1489 / exportHeight);
        image7.setWidth(((3508 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2400 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    ml_801({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1298 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((775 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1322 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2172 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((775 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2208 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((775 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(812 / exportHeight);
        image4.setWidth(((1298 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1586 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2208 + addition) / exportWidth);
        image5.setTop(812 / exportHeight);
        image5.setWidth(((3508 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1586 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(1625 / exportHeight);
        image6.setWidth(((1298 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2400 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1322 + addition) / exportWidth);
        image7.setTop(1625 / exportHeight);
        image7.setWidth(((2172 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2400 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((2208 + addition) / exportWidth);
        image8.setTop(1625 / exportHeight);
        image8.setWidth(((3508 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2400 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    ml_802({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((714 + addition) / exportWidth);
        image1.setTop(163 / exportHeight);
        image1.setWidth(((1377 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((827 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1424 + addition) / exportWidth);
        image2.setTop(163 / exportHeight);
        image2.setWidth(((2088 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((827 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2129 + addition) / exportWidth);
        image3.setTop(163 / exportHeight);
        image3.setWidth(((2792 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((827 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((714 + addition) / exportWidth);
        image4.setTop(868 / exportHeight);
        image4.setWidth(((1377 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1531 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2129 + addition) / exportWidth);
        image5.setTop(868 / exportHeight);
        image5.setWidth(((2792 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1531 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((714 + addition) / exportWidth);
        image6.setTop(1573 / exportHeight);
        image6.setWidth(((1377 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2236 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1424 + addition) / exportWidth);
        image7.setTop(1573 / exportHeight);
        image7.setWidth(((2088 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2236 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((2129 + addition) / exportWidth);
        image8.setTop(1573 / exportHeight);
        image8.setWidth(((2792 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2236 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    ml_901({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1146 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((838 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1183 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2330 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((640 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2367 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((838 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(875 / exportHeight);
        image4.setWidth(((1146 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1515 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1183 + addition) / exportWidth);
        image5.setTop(677 / exportHeight);
        image5.setWidth(((2330 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1720 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2367 + addition) / exportWidth);
        image6.setTop(875 / exportHeight);
        image6.setWidth(((3508 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1515 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((0 + addition) / exportWidth);
        image7.setTop(1549 / exportHeight);
        image7.setWidth(((1146 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2400 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((1183 + addition) / exportWidth);
        image8.setTop(1754 / exportHeight);
        image8.setWidth(((2330 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2400 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((2367 + addition) / exportWidth);
        image9.setTop(1549 / exportHeight);
        image9.setWidth(((3508 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((2400 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
    ml_902({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3508 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1144 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((777 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1181 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2325 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((777 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2362 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3508 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((777 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(811 / exportHeight);
        image4.setWidth(((1144 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1588 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1181 + addition) / exportWidth);
        image5.setTop(811 / exportHeight);
        image5.setWidth(((2325 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1588 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2362 + addition) / exportWidth);
        image6.setTop(811 / exportHeight);
        image6.setWidth(((3508 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1588 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((0 + addition) / exportWidth);
        image7.setTop(1622 / exportHeight);
        image7.setWidth(((1144 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2400 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((1181 + addition) / exportWidth);
        image8.setTop(1622 / exportHeight);
        image8.setWidth(((2325 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2400 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((2362 + addition) / exportWidth);
        image9.setTop(1622 / exportHeight);
        image9.setWidth(((3508 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((2400 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
    ml_credit_asset({ exportWidth = 3540,
        exportHeight = 2400,
        isExport = false,
        rightLeftMargin = 0,
        topBottomMargin = 0,
        isCreditAssetExport = true } = {}) {

        const additionWidth = rightLeftMargin;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(((0 + additionWidth + exportWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(((0 + additionHeight + exportHeight) / exportHeight) -
            collageInfo1.getTop());
        collageInfo1.setIsCreditAsset(isCreditAssetExport);
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    ml_191fr({ exportWidth = 3540,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((871 + additionWidth) / exportWidth);
        collageInfo1.setTop((341 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2670 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1541 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((383 + additionWidth) / exportWidth);
        collageInfo2.setTop((1923 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3158 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2058 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_192fr({ exportWidth = 3540,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((383 + additionWidth) / exportWidth);
        collageInfo1.setTop((308 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3158 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((442 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfo1.setIsText(true);
        collageInfo1.setIsImage(false);
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((0 + additionWidth) / exportWidth);
        collageInfo2.setTop((750 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3540 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2400 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_193fr({ exportWidth = 3540,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3540 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1650 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((383 + additionWidth) / exportWidth);
        collageInfo2.setTop((1957 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3158 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2092 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_194fr({ exportWidth = 3540,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((383 + additionWidth) / exportWidth);
        collageInfo1.setTop((272 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3158 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1833 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((383 + additionWidth) / exportWidth);
        collageInfo2.setTop((2009 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3158 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2143 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_195fr({ exportWidth = 3540,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3540 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((2400 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    ml_196fr({ exportWidth = 3540,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((1096 + additionWidth) / exportWidth);
        collageInfo1.setTop((525 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2446 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1874 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    ml_168_fr({ exportWidth = 3541,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(((isExport ? 871 : 1096) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 227 : 302) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 2670 : 2444) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1426 : 1351) + additionHeight) / exportHeight) -
            collageInfo1.getTop());
        collageInfo1.setDisplayLeft(((1096) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((302) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((2444) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1351) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((347 + additionWidth) / exportWidth);
        collageInfo2.setTop((1499 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3196 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2294 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ml_txt_f_fr({ exportWidth = 3541,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((645 + additionWidth) / exportWidth);
        collageInfo2.setTop((107 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2896 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2292 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    cover_ml_168_fr({ exportWidth = 3541,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        //to get user's actual image coordinates during display and to get white area during export

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(((isExport ? 855 : 1155) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 600 : 750) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 2654 : 2354) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1800 : 1650) + additionHeight) / exportHeight) -
            collageInfo1.getTop());

        //to get user's actual image coordinates during export

        collageInfo1.setDisplayLeft(((1155) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((750) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((2354) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1650) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    cover_ml_plain_f_fr({ exportWidth = 3541,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        return collageInfoList;

    },
    ml_cl_168({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(4509 / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1.setWidth((6009 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1950 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_cl_169({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(1003 / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1.setWidth((2503 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1950 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ml_txt({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const addition = isRightPage ? 3508 : 0;
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((720 + addition) / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1
            .setWidth(((2820 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1950 / exportHeight) - collageInfo1.getTop());
        collageInfo1.setIsText(true);
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_ms_cl_119({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(2999 / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1.setWidth((4199 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_ms_cl_120({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(600 / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1.setWidth((1800 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_layout_127_fr({ exportWidth = 2399,
        exportHeight = 2399,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2399 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(((isExport ? 602 : 714) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 265 : 377) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 1798 : 1686) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1462 : 1350) + additionHeight) / exportHeight) -
            collageInfo1.getTop());
        collageInfo1.setDisplayLeft(((714) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((377) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((1686) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1350) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((146 + additionWidth) / exportWidth);
        collageInfo2.setTop((1487 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2249 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2249 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_layout_txt_f_fr({ exportWidth = 2399,
        exportHeight = 2399,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2399 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((115 + additionWidth) / exportWidth);
        collageInfo2.setTop((294 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2251 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2106 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    cover_ms_layout_127_fr({ exportWidth = 2399,
        exportHeight = 2399,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2399 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();

        //to get user's actual image coordinates during display and to get white area during export
        collageInfo1.setLeft(((isExport ? 450 : 750) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 450 : 750) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 1950 : 1650) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1950 : 1650) + additionHeight) / exportHeight) -
            collageInfo1.getTop());

        //to get user's actual image coordinates during export
        collageInfo1.setDisplayLeft(((750) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((750) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((1650) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1650) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    cover_ms_layout_plain_f_fr({ exportWidth = 2399,
        exportHeight = 2399,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2399 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        return collageInfoList;

    },
    ms_txt({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const addition = isRightPage ? 2400 : 0;
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((450 + addition) / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1
            .setWidth(((1950 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1950 / exportHeight) - collageInfo1.getTop());
        collageInfo1.setIsText(true);
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_101({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(596 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2136 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_102({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1667 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_103({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((732 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_104({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(900 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_105({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((525 + addition) / exportWidth);
        collageInfo1.setTop(658 / exportHeight);
        collageInfo1
            .setWidth(((2410 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2211 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_106({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2100 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_107({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1540 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_108({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((527 + addition) / exportWidth);
        collageInfo1.setTop(517 / exportHeight);
        collageInfo1
            .setWidth(((1877 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1867 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_109({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1800 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_110({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_111({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((1800 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_112({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((600 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_113({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((1500 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2100 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_114({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((900 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2100 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_115({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1500 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_116({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(900 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2100 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_117({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_118({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((2249 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_119({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2099 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1500 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((300 + addition) / exportWidth);
        collageInfo2.setTop(1539 / exportHeight);
        collageInfo2
            .setWidth(((2099 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2099 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_120({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(142 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((758 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((0 + addition) / exportWidth);
        collageInfo3.setTop(900 / exportHeight);
        collageInfo3
            .setWidth(((2400 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2400 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_201({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(770 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(770 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_202({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(1218 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(770 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_203({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1630 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((1630 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_204({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(770 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_205({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(460 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1960 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(460 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1960 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_206({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1500 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1500 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1537 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1500 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_207({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1200 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1200 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1200 + addition) / exportWidth);
        collageInfo2.setTop(1200 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_208({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1200 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((2249 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1200 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(1200 / exportHeight);
        collageInfo2
            .setWidth(((1200 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_209({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1978 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((1064 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1974 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_210({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((422 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((2249 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1335 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1974 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_211({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((525 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1875 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1500 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((525 + addition) / exportWidth);
        collageInfo2.setTop(1537 / exportHeight);
        collageInfo2
            .setWidth(((1875 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_212({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1200 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1200 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_213({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1480 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(920 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_214({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1218 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2249 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1480 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(920 / exportHeight);
        collageInfo2
            .setWidth(((1181 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_215({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((2400 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_216({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((422 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((2249 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((422 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((1297 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1974 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1335 + addition) / exportWidth);
        collageInfo3.setTop(1218 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1974 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_217({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1978 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((1064 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1974 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1102 + addition) / exportWidth);
        collageInfo3.setTop(1218 / exportHeight);
        collageInfo3
            .setWidth(((1978 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1974 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_218({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1200 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1200 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1235 + addition) / exportWidth);
        collageInfo2.setTop(185 / exportHeight);
        collageInfo2
            .setWidth(((2214 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1164 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((185 + addition) / exportWidth);
        collageInfo3.setTop(1235 / exportHeight);
        collageInfo3
            .setWidth(((1164 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2214 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1200 + addition) / exportWidth);
        collageInfo4.setTop(1200 / exportHeight);
        collageInfo4
            .setWidth(((2249 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2249 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_219({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((185 + addition) / exportWidth);
        collageInfo1.setTop(185 / exportHeight);
        collageInfo1
            .setWidth(((1164 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1164 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1200 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1200 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((150 + addition) / exportWidth);
        collageInfo3.setTop(1200 / exportHeight);
        collageInfo3
            .setWidth(((1200 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());

        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1235 + addition) / exportWidth);
        collageInfo4.setTop(1235 / exportHeight);
        collageInfo4
            .setWidth(((2214 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2214 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_220({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(226 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1660 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(226 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1660 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((150 + addition) / exportWidth);
        collageInfo3.setTop(1707 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2173 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_301({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1430 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1464 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1181 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1464 + addition) / exportWidth);
        collageInfo3.setTop(1218 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_302({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((936 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((150 + addition) / exportWidth);
        collageInfo2.setTop(1218 / exportHeight);
        collageInfo2
            .setWidth(((936 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2249 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((969 + addition) / exportWidth);
        collageInfo3.setTop(150 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_303({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1181 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((150 + addition) / exportWidth);
        collageInfo3.setTop(1218 / exportHeight);
        collageInfo3
            .setWidth(((1181 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_304({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1181 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1181 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1218 + addition) / exportWidth);
        collageInfo3.setTop(1218 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_305({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1548 + addition) / exportWidth);
        collageInfo1.setTop(151 / exportHeight);
        collageInfo1
            .setWidth(((2210 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((831 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((869 + addition) / exportWidth);
        collageInfo2.setTop(869 / exportHeight);
        collageInfo2
            .setWidth(((1531 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1531 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((206 + addition) / exportWidth);
        collageInfo3.setTop(1568 / exportHeight);
        collageInfo3
            .setWidth(((869 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_306({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((1181 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((936 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((936 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((150 + addition) / exportWidth);
        collageInfo3.setTop(969 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_307({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((953 + addition) / exportWidth);
        collageInfo1.setTop(151 / exportHeight);
        collageInfo1
            .setWidth(((2249 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((831 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((953 + addition) / exportWidth);
        collageInfo2.setTop(869 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1530 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((953 + addition) / exportWidth);
        collageInfo3.setTop(1568 / exportHeight);
        collageInfo3
            .setWidth(((2249 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2248 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_308({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((830 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1446 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((868 + addition) / exportWidth);
        collageInfo2.setTop(150 / exportHeight);
        collageInfo2
            .setWidth(((1529 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1446 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1567 + addition) / exportWidth);
        collageInfo3.setTop(150 / exportHeight);
        collageInfo3
            .setWidth(((2247 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((1446 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_309({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((151 + addition) / exportWidth);
        collageInfo1.setTop(151 / exportHeight);
        collageInfo1
            .setWidth(((1409 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1409 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1439 + addition) / exportWidth);
        collageInfo2.setTop(151 / exportHeight);
        collageInfo2
            .setWidth(((2249 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((961 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((151 + addition) / exportWidth);
        collageInfo3.setTop(1439 / exportHeight);
        collageInfo3
            .setWidth(((961 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2249 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    ms_310({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((151 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((961 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((961 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((990 + addition) / exportWidth);
        image2.setTop(151 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1409 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1439 + addition) / exportWidth);
        image3.setTop(1439 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ms_311({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2249 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1103 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1218 + addition) / exportWidth);
        image3.setTop(1141 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1812 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ms_312({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1103 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(1141 / exportHeight);
        image2.setWidth(((1181 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1812 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1218 + addition) / exportWidth);
        image3.setTop(150 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ms_313({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((2400 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((778 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(821 / exportHeight);
        image2.setWidth(((2400 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1578 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1621 / exportHeight);
        image3.setWidth(((2400 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    ms_314({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((151 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((1409 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1409 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1439 + addition) / exportWidth);
        image2.setTop(151 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1409 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((151 + addition) / exportWidth);
        image3.setTop(1439 / exportHeight);
        image3.setWidth(((1409 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1439 + addition) / exportWidth);
        collageInfo4.setTop(1439 / exportHeight);
        collageInfo4
            .setWidth(((2249 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2249 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_315({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((151 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((961 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1409 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((990 + addition) / exportWidth);
        image2.setTop(151 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1409 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((151 + addition) / exportWidth);
        image3.setTop(1439 / exportHeight);
        image3.setWidth(((961 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((990 + addition) / exportWidth);
        collageInfo4.setTop(1439 / exportHeight);
        collageInfo4
            .setWidth(((2249 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2249 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_316({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((151 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((1409 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1409 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1439 + addition) / exportWidth);
        image2.setTop(151 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1409 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((151 + addition) / exportWidth);
        image3.setTop(1439 / exportHeight);
        image3.setWidth(((1409 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1439 + addition) / exportWidth);
        collageInfo4.setTop(1439 / exportHeight);
        collageInfo4
            .setWidth(((2249 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2249 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_317({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((151 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((961 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1409 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((990 + addition) / exportWidth);
        image2.setTop(151 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1409 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((151 + addition) / exportWidth);
        image3.setTop(1439 / exportHeight);
        image3.setWidth(((961 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((990 + addition) / exportWidth);
        collageInfo4.setTop(1439 / exportHeight);
        collageInfo4
            .setWidth(((2249 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2249 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_318({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_319({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());

        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_320({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2249 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1103 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1218 + addition) / exportWidth);
        image3.setTop(1141 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1812 / exportHeight) - image3.getTop());

        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1856 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_321({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((778 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1664 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((821 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((1578 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1664 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1621 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((2400 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1664 / exportHeight) - image3.getTop());

        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1789 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2255 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_401({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_402({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1481 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((881 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1518 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(919 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_403({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((2249 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1535 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(1575 / exportHeight);
        image2.setWidth(((824 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2249 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((862 + addition) / exportWidth);
        image3.setTop(1575 / exportHeight);
        image3.setWidth(((1537 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1575 + addition) / exportWidth);
        image4.setTop(1575 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_404({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2400 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2400 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2400 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2400 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_405({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((936 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((936 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1464 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1464 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_406({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((985 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((985 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1023 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1858 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((985 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1023 / exportHeight);
        image3.setWidth(((985 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1858 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1023 + addition) / exportWidth);
        image4.setTop(1023 / exportHeight);
        image4.setWidth(((1858 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1858 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_407({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((541 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1377 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((985 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1414 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((985 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((541 + addition) / exportWidth);
        image3.setTop(1023 / exportHeight);
        image3.setWidth(((1377 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1858 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1414 + addition) / exportWidth);
        image4.setTop(1023 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1858 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_408({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(862 / exportHeight);
        image2.setWidth(((1181 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1537 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1575 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(150 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_409({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((346 + addition) / exportWidth);
        image1.setTop(346 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(346 / exportHeight);
        image2.setWidth(((2054 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((346 + addition) / exportWidth);
        image3.setTop(1218 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2054 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(1218 / exportHeight);
        image4.setWidth(((2054 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2054 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_410({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((985 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((985 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1023 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1858 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((985 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1023 / exportHeight);
        image3.setWidth(((985 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1858 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1023 + addition) / exportWidth);
        image4.setTop(1023 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_411({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((843 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1527 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1181 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1565 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1181 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((843 + addition) / exportWidth);
        image3.setTop(1219 / exportHeight);
        image3.setWidth(((1527 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1565 + addition) / exportWidth);
        image4.setTop(1219 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_412({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(152 / exportHeight);
        image1.setWidth(((985 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((987 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1414 + addition) / exportWidth);
        image2.setTop(152 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((987 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1414 / exportHeight);
        image3.setWidth(((985 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2249 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1414 + addition) / exportWidth);
        image4.setTop(1414 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_413({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((164 + addition) / exportWidth);
        image1.setTop(378 / exportHeight);
        image1.setWidth(((1250 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1132 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1403 + addition) / exportWidth);
        image2.setTop(147 / exportHeight);
        image2.setWidth(((2235 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1132 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((164 + addition) / exportWidth);
        image3.setTop(1267 / exportHeight);
        image3.setWidth(((996 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2252 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1149 + addition) / exportWidth);
        image4.setTop(1267 / exportHeight);
        image4.setWidth(((2235 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2021 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    ms_414({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((936 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((936 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(988 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1412 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1464 / exportHeight);
        image4.setWidth(((1181 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1218 + addition) / exportWidth);
        image5.setTop(1464 / exportHeight);
        image5.setWidth(((2249 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_415({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];

        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((2249 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((616 / exportHeight) - image1.getTop());
        image1.isText = true;
        image1.fontName = "TimesNewRoman";
        image1.fontSizeInPoints = 20;
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(661 / exportHeight);
        image2.setWidth(((1177 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1433 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1222 + addition) / exportWidth);
        image3.setTop(661 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1433 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1477 / exportHeight);
        image4.setWidth(((1177 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1222 + addition) / exportWidth);
        image5.setTop(1477 / exportHeight);
        image5.setWidth(((2249 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_501({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1214 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1581 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(1618 / exportHeight);
        image2.setWidth(((1214 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2400 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1252 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((2400 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((781 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1252 + addition) / exportWidth);
        image4.setTop(819 / exportHeight);
        image4.setWidth(((2400 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1581 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1252 + addition) / exportWidth);
        image5.setTop(1618 / exportHeight);
        image5.setWidth(((2400 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2400 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_502({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((153 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1212 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1179 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((153 + addition) / exportWidth);
        image2.setTop(1217 / exportHeight);
        image2.setWidth(((1212 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2246 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1246 + addition) / exportWidth);
        image3.setTop(153 / exportHeight);
        image3.setWidth(((2246 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((834 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1246 + addition) / exportWidth);
        image4.setTop(867 / exportHeight);
        image4.setWidth(((2246 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1532 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1246 + addition) / exportWidth);
        image5.setTop(1565 / exportHeight);
        image5.setWidth(((2246 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2246 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_503({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(153 / exportHeight);
        image1.setWidth(((2246 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((895 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(932 / exportHeight);
        image2.setWidth(((1181 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1571 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1218 + addition) / exportWidth);
        image3.setTop(932 / exportHeight);
        image3.setWidth(((2246 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1571 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1608 / exportHeight);
        image4.setWidth(((1181 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2246 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1218 + addition) / exportWidth);
        image5.setTop(1608 / exportHeight);
        image5.setWidth(((2246 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2246 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_504({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((977 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((2246 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((936 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((977 + addition) / exportWidth);
        image2.setTop(973 / exportHeight);
        image2.setWidth(((1594 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1591 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1631 + addition) / exportWidth);
        image3.setTop(973 / exportHeight);
        image3.setWidth(((2246 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1591 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((977 + addition) / exportWidth);
        image4.setTop(1629 / exportHeight);
        image4.setWidth(((1594 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2246 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1631 + addition) / exportWidth);
        image5.setTop(1629 / exportHeight);
        image5.setWidth(((2246 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2246 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_505({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((155 + addition) / exportWidth);
        image1.setTop(565 / exportHeight);
        image1.setWidth(((772 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1182 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((155 + addition) / exportWidth);
        image2.setTop(1219 / exportHeight);
        image2.setWidth(((772 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1834 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((804 + addition) / exportWidth);
        image3.setTop(565 / exportHeight);
        image3.setWidth(((1590 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1834 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1627 + addition) / exportWidth);
        image4.setTop(565 / exportHeight);
        image4.setWidth(((2245 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1182 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1627 + addition) / exportWidth);
        image5.setTop(1219 / exportHeight);
        image5.setWidth(((2245 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1834 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_506({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((1419 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((937 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(975 / exportHeight);
        image2.setWidth(((767 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1593 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((804 + addition) / exportWidth);
        image3.setTop(975 / exportHeight);
        image3.setWidth(((1419 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1593 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1630 / exportHeight);
        image4.setWidth(((767 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2248 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((804 + addition) / exportWidth);
        image5.setTop(1630 / exportHeight);
        image5.setWidth(((1419 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2248 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_507({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1557 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2249 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1594 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((650 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1594 + addition) / exportWidth);
        image3.setTop(686 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1174 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1594 + addition) / exportWidth);
        image4.setTop(1211 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1712 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1594 + addition) / exportWidth);
        image5.setTop(1749 / exportHeight);
        image5.setWidth(((2249 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    ms_601({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((825 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1182 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((862 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1537 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1182 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1575 + addition) / exportWidth);
        image3.setTop(150 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1182 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1219 / exportHeight);
        image4.setWidth(((825 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((862 + addition) / exportWidth);
        image5.setTop(1219 / exportHeight);
        image5.setWidth(((1537 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1575 + addition) / exportWidth);
        image6.setTop(1219 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_602({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(508 / exportHeight);
        image1.setWidth(((825 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1180 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((861 + addition) / exportWidth);
        image2.setTop(508 / exportHeight);
        image2.setWidth(((1537 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1180 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1574 + addition) / exportWidth);
        image3.setTop(508 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1180 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1217 / exportHeight);
        image4.setWidth(((825 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1892 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((861 + addition) / exportWidth);
        image5.setTop(1217 / exportHeight);
        image5.setWidth(((1537 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1892 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1574 + addition) / exportWidth);
        image6.setTop(1217 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1892 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_603({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((508 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1182 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1219 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1892 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((508 + addition) / exportWidth);
        image3.setTop(861 / exportHeight);
        image3.setWidth(((1182 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1537 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1219 + addition) / exportWidth);
        image4.setTop(861 / exportHeight);
        image4.setWidth(((1892 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1537 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((508 + addition) / exportWidth);
        image5.setTop(1574 / exportHeight);
        image5.setWidth(((1182 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1219 + addition) / exportWidth);
        image6.setTop(1574 / exportHeight);
        image6.setWidth(((1892 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_604({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(151 / exportHeight);
        image1.setWidth(((825 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((824 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((861 + addition) / exportWidth);
        image2.setTop(151 / exportHeight);
        image2.setWidth(((1537 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((824 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1574 + addition) / exportWidth);
        image3.setTop(151 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((824 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1575 / exportHeight);
        image4.setWidth(((825 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((861 + addition) / exportWidth);
        image5.setTop(1575 / exportHeight);
        image5.setWidth(((1537 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1574 + addition) / exportWidth);
        image6.setTop(1575 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_605({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1587 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((775 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1625 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2400 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((775 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(812 / exportHeight);
        image3.setWidth(((1587 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1587 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1625 + addition) / exportWidth);
        image4.setTop(812 / exportHeight);
        image4.setWidth(((2400 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1587 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((0 + addition) / exportWidth);
        image5.setTop(1625 / exportHeight);
        image5.setWidth(((1587 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2400 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1625 + addition) / exportWidth);
        image6.setTop(1625 / exportHeight);
        image6.setWidth(((2400 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2400 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_606({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((806 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((842 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(862 / exportHeight);
        image3.setWidth(((1556 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1537 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1592 + addition) / exportWidth);
        image4.setTop(862 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1537 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((150 + addition) / exportWidth);
        image5.setTop(1575 / exportHeight);
        image5.setWidth(((806 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((842 + addition) / exportWidth);
        image6.setTop(1575 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_607({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1587 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1587 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1625 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2400 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((775 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1625 + addition) / exportWidth);
        image3.setTop(812 / exportHeight);
        image3.setWidth(((2400 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1587 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1625 / exportHeight);
        image4.setWidth(((775 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2400 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((812 + addition) / exportWidth);
        image5.setTop(1625 / exportHeight);
        image5.setWidth(((1587 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2400 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1625 + addition) / exportWidth);
        image6.setTop(1625 / exportHeight);
        image6.setWidth(((2400 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2400 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_608({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((899 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((921 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((937 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((921 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(958 / exportHeight);
        image3.setWidth(((1441 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1685 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1722 / exportHeight);
        image4.setWidth(((777 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((814 + addition) / exportWidth);
        image5.setTop(1722 / exportHeight);
        image5.setWidth(((1441 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1479 + addition) / exportWidth);
        image6.setTop(958 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_609({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1557 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1174 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1594 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((650 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1594 + addition) / exportWidth);
        image3.setTop(686 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1174 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1211 / exportHeight);
        image4.setWidth(((1557 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1594 + addition) / exportWidth);
        image5.setTop(1211 / exportHeight);
        image5.setWidth(((2249 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1712 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1594 + addition) / exportWidth);
        image6.setTop(1749 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_610({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((2249 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((904 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(942 / exportHeight);
        image2.setWidth(((1181 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1537 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1218 + addition) / exportWidth);
        image3.setTop(942 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1537 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1575 / exportHeight);
        image4.setWidth(((825 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2249 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((862 + addition) / exportWidth);
        image5.setTop(1575 / exportHeight);
        image5.setWidth(((1537 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1575 + addition) / exportWidth);
        image6.setTop(1575 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_611({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((775 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2400 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((775 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(812 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1587 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(812 / exportHeight);
        image4.setWidth(((2400 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1587 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((0 + addition) / exportWidth);
        image5.setTop(1625 / exportHeight);
        image5.setWidth(((1181 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2400 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1218 + addition) / exportWidth);
        image6.setTop(1625 / exportHeight);
        image6.setWidth(((2400 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2400 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    ms_701({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1535 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((830 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1573 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2252 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((830 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(867 / exportHeight);
        image3.setWidth(((826 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1547 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((863 + addition) / exportWidth);
        image4.setTop(867 / exportHeight);
        image4.setWidth(((1539 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1547 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1576 + addition) / exportWidth);
        image5.setTop(867 / exportHeight);
        image5.setWidth(((2252 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1547 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1585 / exportHeight);
        image6.setWidth(((1181 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1218 + addition) / exportWidth);
        image7.setTop(1585 / exportHeight);
        image7.setWidth(((2249 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    ms_702({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((826 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((830 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((863 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((830 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(867 / exportHeight);
        image3.setWidth(((826 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1547 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((863 + addition) / exportWidth);
        image4.setTop(867 / exportHeight);
        image4.setWidth(((1539 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1547 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1576 + addition) / exportWidth);
        image5.setTop(867 / exportHeight);
        image5.setWidth(((2252 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1547 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1585 / exportHeight);
        image6.setWidth(((826 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((863 + addition) / exportWidth);
        image7.setTop(1585 / exportHeight);
        image7.setWidth(((2249 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    ms_703({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1181 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((830 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1218 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((830 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(867 / exportHeight);
        image3.setWidth(((826 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1547 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((863 + addition) / exportWidth);
        image4.setTop(867 / exportHeight);
        image4.setWidth(((1539 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1547 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1576 + addition) / exportWidth);
        image5.setTop(867 / exportHeight);
        image5.setWidth(((2252 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1547 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1585 / exportHeight);
        image6.setWidth(((1181 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2250 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1218 + addition) / exportWidth);
        image7.setTop(1585 / exportHeight);
        image7.setWidth(((2252 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2250 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    ms_704({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((899 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((921 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((937 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((921 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(958 / exportHeight);
        image3.setWidth(((1181 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1685 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1218 + addition) / exportWidth);
        image4.setTop(958 / exportHeight);
        image4.setWidth(((2249 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1685 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((150 + addition) / exportWidth);
        image5.setTop(1722 / exportHeight);
        image5.setWidth(((796 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2249 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((834 + addition) / exportWidth);
        image6.setTop(1722 / exportHeight);
        image6.setWidth(((1523 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1560 + addition) / exportWidth);
        image7.setTop(1722 / exportHeight);
        image7.setWidth(((2249 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    ms_801({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((796 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((749 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((834 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1523 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((749 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1560 + addition) / exportWidth);
        image3.setTop(150 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((749 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(787 / exportHeight);
        image4.setWidth(((1181 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1613 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1218 + addition) / exportWidth);
        image5.setTop(787 / exportHeight);
        image5.setWidth(((2249 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1613 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1650 / exportHeight);
        image6.setWidth(((796 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((834 + addition) / exportWidth);
        image7.setTop(1650 / exportHeight);
        image7.setWidth(((1523 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((1560 + addition) / exportWidth);
        image8.setTop(1650 / exportHeight);
        image8.setWidth(((2249 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2249 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    ms_802({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((825 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((862 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1537 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1575 + addition) / exportWidth);
        image3.setTop(150 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((825 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(863 / exportHeight);
        image4.setWidth(((825 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1538 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1575 + addition) / exportWidth);
        image5.setTop(863 / exportHeight);
        image5.setWidth(((2249 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1538 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1575 / exportHeight);
        image6.setWidth(((825 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2249 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((862 + addition) / exportWidth);
        image7.setTop(1575 / exportHeight);
        image7.setWidth(((1537 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((1575 + addition) / exportWidth);
        image8.setTop(1575 / exportHeight);
        image8.setWidth(((2249 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2249 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    ms_901({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((825 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((862 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1537 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1575 + addition) / exportWidth);
        image3.setTop(150 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((825 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(863 / exportHeight);
        image4.setWidth(((825 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1538 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((862 + addition) / exportWidth);
        image5.setTop(863 / exportHeight);
        image5.setWidth(((1537 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1538 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1575 + addition) / exportWidth);
        image6.setTop(863 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1538 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((150 + addition) / exportWidth);
        image7.setTop(1575 / exportHeight);
        image7.setWidth(((825 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((862 + addition) / exportWidth);
        image8.setTop(1575 / exportHeight);
        image8.setWidth(((1537 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2249 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((1575 + addition) / exportWidth);
        image9.setTop(1575 / exportHeight);
        image9.setWidth(((2249 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((2249 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
    ms_902({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2400 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((599 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((825 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((637 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((1724 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((825 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1762 + addition) / exportWidth);
        image3.setTop(150 / exportHeight);
        image3.setWidth(((2249 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((825 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(862 / exportHeight);
        image4.setWidth(((824 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1537 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((862 + addition) / exportWidth);
        image5.setTop(862 / exportHeight);
        image5.setWidth(((1537 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1537 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1574 + addition) / exportWidth);
        image6.setTop(862 / exportHeight);
        image6.setWidth(((2249 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1537 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((150 + addition) / exportWidth);
        image7.setTop(1575 / exportHeight);
        image7.setWidth(((599 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2249 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((637 + addition) / exportWidth);
        image8.setTop(1575 / exportHeight);
        image8.setWidth(((1724 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2249 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((1762 + addition) / exportWidth);
        image9.setTop(1575 / exportHeight);
        image9.setWidth(((2249 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((2249 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
    ms_119fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((600 + addition) / exportWidth);
        collageInfo1.setTop(900 / exportHeight);
        collageInfo1
            .setWidth(((1800 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2100 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_120fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2700 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_121fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(305 / exportHeight);
        collageInfo1
            .setWidth(((2398 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1815 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_122fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((600 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((1800 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_123fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_124fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(1200 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_125ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((652) / exportWidth);
        collageInfo1.setTop(900 / exportHeight);
        collageInfo1.setWidth(((2451) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2099 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    ms_220fr({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 2961 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(475 / exportHeight);
        collageInfo1
            .setWidth(((1185 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1774 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1218 + addition) / exportWidth);
        collageInfo2.setTop(475 / exportHeight);
        collageInfo2
            .setWidth(((2398 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1774 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_221ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((652) / exportWidth);
        collageInfo1.setTop(1009 / exportHeight);
        collageInfo1.setWidth(((2451) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2099 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(false);
        collageInfo2.setLeft((652) / exportWidth);
        collageInfo2.setTop(900 / exportHeight);
        collageInfo2.setWidth(((2451) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2099 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_414ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((677) / exportWidth);
        collageInfo1.setTop(625 / exportHeight);
        collageInfo1.setWidth(((1533) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1481 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(false);
        collageInfo2.setLeft((1570) / exportWidth);
        collageInfo2.setTop(625 / exportHeight);
        collageInfo2.setWidth(((2426) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1481 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(false);
        collageInfo3.setLeft((677) / exportWidth);
        collageInfo3.setTop(1518 / exportHeight);
        collageInfo3.setWidth(((1533) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2374 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(false);
        collageInfo4.setLeft((1570) / exportWidth);
        collageInfo4.setTop(1518 / exportHeight);
        collageInfo4.setWidth(((2426) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2374 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_415ba({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(false);
        collageInfo1.setLeft((677) / exportWidth);
        collageInfo1.setTop(625 / exportHeight);
        collageInfo1.setWidth(((1533) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1481 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(false);
        collageInfo2.setLeft((1570) / exportWidth);
        collageInfo2.setTop(625 / exportHeight);
        collageInfo2.setWidth(((2426) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1481 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(false);
        collageInfo3.setLeft((677) / exportWidth);
        collageInfo3.setTop(1518 / exportHeight);
        collageInfo3.setWidth(((1533) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2374 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(false);
        collageInfo4.setLeft((1570) / exportWidth);
        collageInfo4.setTop(1518 / exportHeight);
        collageInfo4.setWidth(((2426) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2374 / exportHeight) - collageInfo4.getTop());
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    ms_191fr({ exportWidth = 2400,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2400 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((600 + additionWidth) / exportWidth);
        collageInfo1.setTop((355 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((1799 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1555 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((171 + additionWidth) / exportWidth);
        collageInfo2.setTop((1910 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2271 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2044 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_192fr({ exportWidth = 2400,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2400 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((171 + additionWidth) / exportWidth);
        collageInfo2.setTop((383 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2271 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((517 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((900 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2400 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((2400 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    ms_193fr({ exportWidth = 2400,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2400 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2400 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1500 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((171 + additionWidth) / exportWidth);
        collageInfo2.setTop((1882 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2271 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2017 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_194fr({ exportWidth = 2400,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2400 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((300 + additionWidth) / exportWidth);
        collageInfo1.setTop((355 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2099 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1555 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((171 + additionWidth) / exportWidth);
        collageInfo2.setTop((1910 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2271 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2044 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    ms_195fr({ exportWidth = 2400,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2400 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2400 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((2400 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    ms_196fr({ exportWidth = 2400,
        exportHeight = 2400,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (2400 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((600 + additionWidth) / exportWidth);
        collageInfo1.setTop((600 + additionHeight) / exportHeight);
        collageInfo1.isCircle = true;
        collageInfo1.setWidth(
            ((1800 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1800 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    layout_bl_cl_106({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(6542 / exportWidth);
        collageInfo1.setTop(675 / exportHeight);
        collageInfo1.setWidth((8192 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2324 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_cl_107({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(1631 / exportWidth);
        collageInfo1.setTop(675 / exportHeight);
        collageInfo1.setWidth((3280 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2324 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_txt({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const addition = isRightPage ? 4911 : 0;
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1275 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((3675 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfo1.setIsText(true);
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_101({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(798 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2723 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_102({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3801 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_103({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(745 / exportHeight);
        collageInfo1
            .setWidth(((3645 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_104({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(745 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_105({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1110 + addition) / exportWidth);
        collageInfo1.setTop(779 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2720 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_106({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((775 + addition) / exportWidth);
        collageInfo1.setTop(531 / exportHeight);
        collageInfo1
            .setWidth(((4055 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2467 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_107({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((461 + addition) / exportWidth);
        collageInfo1.setTop(281 / exportHeight);
        collageInfo1
            .setWidth(((3529 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2717 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_108({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((371 + addition) / exportWidth);
        collageInfo1.setTop(206 / exportHeight);
        collageInfo1
            .setWidth(((4539 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2793 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_109({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2009 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_110({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2670 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2621 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_111({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1267 + addition) / exportWidth);
        collageInfo1.setTop(745 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_112({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1111 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_113({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(779 / exportHeight);
        collageInfo1
            .setWidth(((3801 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2720 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_114({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((2241 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2621 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_115({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((816 + addition) / exportWidth);
        collageInfo1.setTop(343 / exportHeight);
        collageInfo1
            .setWidth(((4096 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2009 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_116({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1405 + addition) / exportWidth);
        collageInfo1.setTop(188 / exportHeight);
        collageInfo1
            .setWidth(((3506 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2811 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_117({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((775 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4136 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_118({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1412 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4492 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_119({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((420 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3090 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2621 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_120({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(610 / exportHeight);
        collageInfo1
            .setWidth(((3542 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2388 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_121({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((420 + addition) / exportWidth);
        collageInfo1.setTop(281 / exportHeight);
        collageInfo1
            .setWidth(((3151 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2717 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_122({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1369 + addition) / exportWidth);
        collageInfo1.setTop(610 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2388 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_123({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(394 / exportHeight);
        collageInfo1
            .setWidth(((4405 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2604 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_124({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_125({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((2448 + addition) / exportWidth);
        collageInfo1.setTop(281 / exportHeight);
        collageInfo1
            .setWidth(((4456 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2538 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_126({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((452 + addition) / exportWidth);
        collageInfo1.setTop(257 / exportHeight);
        collageInfo1
            .setWidth(((4459 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2268 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bl_127({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((452 + addition) / exportWidth);
        collageInfo1.setTop(494 / exportHeight);
        collageInfo1
            .setWidth(((4459 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2505 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bl_layout_128fr({ exportWidth = 4949,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (4949 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((1274 + additionWidth) / exportWidth);
        collageInfo1.setTop((455 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3674 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1955 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1124 + additionWidth) / exportWidth);
        collageInfo2.setTop((2410 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3824 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2544 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bl_layout_129fr({ exportWidth = 4949,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (4949 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1136 + additionWidth) / exportWidth);
        collageInfo2.setTop((458 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3836 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((592 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((1050 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((4949 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((3000 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    bl_layout_130fr({ exportWidth = 4949,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (4949 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((4949 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1950 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1136 + additionWidth) / exportWidth);
        collageInfo2.setTop((2407 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3836 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2542 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bl_layout_131fr({ exportWidth = 4949,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (4949 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((1124 + additionWidth) / exportWidth);
        collageInfo1.setTop((455 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3824 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1955 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1124 + additionWidth) / exportWidth);
        collageInfo2.setTop((2410 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3824 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2544 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bl_layout_132fr({ exportWidth = 4949,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (4949 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((4949 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((3000 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    bl_layout_133fr({ exportWidth = 4949,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (4949 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((1724 + additionWidth) / exportWidth);
        collageInfo1.setTop((750 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3224 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((2250 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    cover_bl_layout_134_fr({ exportWidth = 4950,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1
            .setLeft(((isExport ? 1427 : 1577) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 229 : 379) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 3522 : 3372) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1724 : 1574) + additionHeight) / exportHeight) -
            collageInfo1.getTop());
        collageInfo1.setDisplayLeft(((1577) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((379) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((3372) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1574) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    cover_bl_layout_plain_f_fr({ exportWidth = 4950,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        return collageInfoList;

    },
    bl_layout_134_fr({ exportWidth = 4950,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1
            .setLeft(((isExport ? 1427 : 1577) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 229 : 379) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 3522 : 3372) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1724 : 1574) + additionHeight) / exportHeight) -
            collageInfo1.getTop());
        collageInfo1.setDisplayLeft(((1577) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((379) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((3372) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1574) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1001 + additionWidth) / exportWidth);
        collageInfo2.setTop((1750 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3949 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2868 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bl_layout_txt_f_fr({ exportWidth = 4950,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1001 + additionWidth) / exportWidth);
        collageInfo2.setTop((292 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((3949 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2707 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bigLandscapeDigiPressCover3ExportCollage({ width = 0, height = 0 } = {}) {

        const exportCollageInfoList = [];

        const collageInfoExport1 = new CollageInfo();
        collageInfoExport1.setLeft(5463 / width);
        collageInfoExport1.setTop(300 / height);
        collageInfoExport1.setWidth((10411 / width) - collageInfoExport1.getLeft());
        collageInfoExport1.setHeight((2399 / height) - collageInfoExport1.getTop());
        exportCollageInfoList.push(collageInfoExport1);

        const collageInfoExport2 = new CollageInfo();
        collageInfoExport2.setLeft(6437 / width);
        collageInfoExport2.setTop(2751 / height);
        collageInfoExport2.setWidth((9437 / width) - collageInfoExport2.getLeft());
        collageInfoExport2.setHeight((2947 / height) - collageInfoExport2.getTop());
        collageInfoExport2.setIsText(true);
        exportCollageInfoList.push(collageInfoExport2);

        return exportCollageInfoList;

    },
    layout_bl_201({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((541 + addition) / exportWidth);
        collageInfo1.setTop(773 / exportHeight);
        collageInfo1
            .setWidth(((2425 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2769 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2485 + addition) / exportWidth);
        collageInfo2.setTop(773 / exportHeight);
        collageInfo2
            .setWidth(((4369 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2769 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_204({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2168 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((0 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((2168 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_205({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((542 + addition) / exportWidth);
        collageInfo1.setTop(1003 / exportHeight);
        collageInfo1
            .setWidth(((2425 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2718 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2485 + addition) / exportWidth);
        collageInfo2.setTop(1003 / exportHeight);
        collageInfo2
            .setWidth(((4368 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2718 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_206({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2426 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2486 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((4911 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_208({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((503 + addition) / exportWidth);
        collageInfo1.setTop(293 / exportHeight);
        collageInfo1
            .setWidth(((2426 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2706 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2486 + addition) / exportWidth);
        collageInfo2.setTop(293 / exportHeight);
        collageInfo2
            .setWidth(((4407 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2706 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_209({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(375 / exportHeight);
        collageInfo1
            .setWidth(((2426 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2624 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2486 + addition) / exportWidth);
        collageInfo2.setTop(375 / exportHeight);
        collageInfo2
            .setWidth(((4911 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2624 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_210({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((460 + addition) / exportWidth);
        collageInfo1.setTop(291 / exportHeight);
        collageInfo1
            .setWidth(((3193 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2229 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((3253 + addition) / exportWidth);
        collageInfo2.setTop(291 / exportHeight);
        collageInfo2
            .setWidth(((4450 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2229 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_211({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((2349 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4648 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2349 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((4648 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_212({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((642 + addition) / exportWidth);
        collageInfo1.setTop(568 / exportHeight);
        collageInfo1
            .setWidth(((2743 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2803 + addition) / exportWidth);
        collageInfo2.setTop(568 / exportHeight);
        collageInfo2
            .setWidth(((4911 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_213({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((350 + addition) / exportWidth);
        collageInfo1.setTop(1080 / exportHeight);
        collageInfo1
            .setWidth(((2422 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2699 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2482 + addition) / exportWidth);
        collageInfo2.setTop(300 / exportHeight);
        collageInfo2
            .setWidth(((4561 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2699 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_214({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(464 / exportHeight);
        collageInfo1
            .setWidth(((1784 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1844 + addition) / exportWidth);
        collageInfo2.setTop(845 / exportHeight);
        collageInfo2
            .setWidth(((3502 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_215({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((976 + addition) / exportWidth);
        collageInfo1.setTop(392 / exportHeight);
        collageInfo1
            .setWidth(((2426 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2607 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2486 + addition) / exportWidth);
        collageInfo2.setTop(691 / exportHeight);
        collageInfo2
            .setWidth(((3934 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2309 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_216({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((420 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2585 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1929 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((420 + addition) / exportWidth);
        collageInfo2.setTop(1989 / exportHeight);
        collageInfo2
            .setWidth(((2585 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_217({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((420 + addition) / exportWidth);
        collageInfo1.setTop(375 / exportHeight);
        collageInfo1
            .setWidth(((3421 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1786 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((420 + addition) / exportWidth);
        collageInfo2.setTop(1846 / exportHeight);
        collageInfo2
            .setWidth(((1773 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2624 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_219({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((2426 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2389 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2486 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((4911 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2389 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_220({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((2435 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((4911 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1801 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2435 + addition) / exportWidth);
        collageInfo2.setTop(1861 / exportHeight);
        collageInfo2
            .setWidth(((4911 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_221({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((436 + addition) / exportWidth);
        collageInfo1.setTop(281 / exportHeight);
        collageInfo1
            .setWidth(((2426 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2059 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2486 + addition) / exportWidth);
        collageInfo2.setTop(281 / exportHeight);
        collageInfo2
            .setWidth(((4474 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2059 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_222({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((766 + addition) / exportWidth);
        collageInfo1.setTop(299 / exportHeight);
        collageInfo1
            .setWidth(((4145 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((766 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((4145 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2700 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    layout_bl_301({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3220 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2306 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((3279 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((4911 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1123 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((3279 + addition) / exportWidth);
        collageInfo3.setTop(1183 / exportHeight);
        collageInfo3
            .setWidth(((4911 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2306 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_302({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((461 + addition) / exportWidth);
        collageInfo1.setTop(281 / exportHeight);
        collageInfo1
            .setWidth(((3192 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2718 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((3252 + addition) / exportWidth);
        collageInfo2.setTop(281 / exportHeight);
        collageInfo2
            .setWidth(((4451 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1470 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((3252 + addition) / exportWidth);
        collageInfo3.setTop(1530 / exportHeight);
        collageInfo3
            .setWidth(((4451 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2718 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_303({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((500 + addition) / exportWidth);
        collageInfo1.setTop(281 / exportHeight);
        collageInfo1
            .setWidth(((2596 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2718 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2656 + addition) / exportWidth);
        collageInfo2.setTop(281 / exportHeight);
        collageInfo2
            .setWidth(((4412 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1062 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2656 + addition) / exportWidth);
        collageInfo3.setTop(1122 / exportHeight);
        collageInfo3
            .setWidth(((4412 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2718 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_304({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((566 + addition) / exportWidth);
        collageInfo1.setTop(177 / exportHeight);
        collageInfo1
            .setWidth(((1925 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1271 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((566 + addition) / exportWidth);
        collageInfo2.setTop(1331 / exportHeight);
        collageInfo2
            .setWidth(((1925 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2425 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1985 + addition) / exportWidth);
        collageInfo3.setTop(176 / exportHeight);
        collageInfo3
            .setWidth(((4345 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2423 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_305({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((355 + addition) / exportWidth);
        collageInfo1.setTop(296 / exportHeight);
        collageInfo1
            .setWidth(((2425 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2485 + addition) / exportWidth);
        collageInfo2.setTop(296 / exportHeight);
        collageInfo2
            .setWidth(((4555 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1470 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2485 + addition) / exportWidth);
        collageInfo3.setTop(1530 / exportHeight);
        collageInfo3
            .setWidth(((4555 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2703 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_306({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((611 + addition) / exportWidth);
        collageInfo1.setTop(192 / exportHeight);
        collageInfo1
            .setWidth(((2425 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1034 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((2485 + addition) / exportWidth);
        collageInfo2.setTop(192 / exportHeight);
        collageInfo2
            .setWidth(((4299 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1034 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((611 + addition) / exportWidth);
        collageInfo3.setTop(1094 / exportHeight);
        collageInfo3
            .setWidth(((4299 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2368 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_307({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((532 + addition) / exportWidth);
        collageInfo1.setTop(336 / exportHeight);
        collageInfo1
            .setWidth(((1777 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2024 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1837 + addition) / exportWidth);
        collageInfo2.setTop(336 / exportHeight);
        collageInfo2
            .setWidth(((3075 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2024 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((3135 + addition) / exportWidth);
        collageInfo3.setTop(336 / exportHeight);
        collageInfo3
            .setWidth(((4379 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2024 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_308({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((929 + addition) / exportWidth);
        collageInfo1.setTop(276 / exportHeight);
        collageInfo1
            .setWidth(((2423 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1861 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((929 + addition) / exportWidth);
        collageInfo2.setTop(1926 / exportHeight);
        collageInfo2
            .setWidth(((2423 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2724 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2488 + addition) / exportWidth);
        collageInfo3.setTop(276 / exportHeight);
        collageInfo3
            .setWidth(((3982 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2724 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_309({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1998 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1102 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((0 + addition) / exportWidth);
        collageInfo2.setTop(1102 / exportHeight);
        collageInfo2
            .setWidth(((1998 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2204 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1998 + addition) / exportWidth);
        collageInfo3.setTop(0 / exportHeight);
        collageInfo3
            .setWidth(((4911 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2204 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    layout_bl_310({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((908 + addition) / exportWidth);
        image1.setTop(284 / exportHeight);
        image1.setWidth(((2014 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1105 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2074 + addition) / exportWidth);
        image2.setTop(284 / exportHeight);
        image2.setWidth(((4003 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1105 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((908 + addition) / exportWidth);
        image3.setTop(1165 / exportHeight);
        image3.setWidth(((4003 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2715 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    layout_bl_311({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1885 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((4423 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((964 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1885 + addition) / exportWidth);
        image2.setTop(1024 / exportHeight);
        image2.setWidth(((4423 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1975 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1885 + addition) / exportWidth);
        image3.setTop(2035 / exportHeight);
        image3.setWidth(((4423 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    layout_bl_312({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((586 + addition) / exportWidth);
        image1.setTop(670 / exportHeight);
        image1.setWidth(((2064 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1707 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2124 + addition) / exportWidth);
        image2.setTop(346 / exportHeight);
        image2.setWidth(((4325 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1707 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((586 + addition) / exportWidth);
        image3.setTop(1767 / exportHeight);
        image3.setWidth(((2064 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2653 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    layout_bl_313({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(346 / exportHeight);
        image1.setWidth(((1637 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2179 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1637 + addition) / exportWidth);
        image2.setTop(346 / exportHeight);
        image2.setWidth(((3274 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2179 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3274 + addition) / exportWidth);
        image3.setTop(346 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2179 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    layout_bl_401({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((779 + addition) / exportWidth);
        image1.setTop(635 / exportHeight);
        image1.setWidth(((2390 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1638 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2520 + addition) / exportWidth);
        image2.setTop(635 / exportHeight);
        image2.setWidth(((4132 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1638 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((779 + addition) / exportWidth);
        image3.setTop(1772 / exportHeight);
        image3.setWidth(((2390 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2775 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2520 + addition) / exportWidth);
        image4.setTop(1772 / exportHeight);
        image4.setWidth(((4132 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2775 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_402({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((674 + addition) / exportWidth);
        image1.setTop(279 / exportHeight);
        image1.setWidth(((2425 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2485 + addition) / exportWidth);
        image2.setTop(279 / exportHeight);
        image2.setWidth(((4236 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((674 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((2425 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2720 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2485 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((4236 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2720 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_403({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((579 + addition) / exportWidth);
        image1.setTop(410 / exportHeight);
        image1.setWidth(((2424 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1704 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((579 + addition) / exportWidth);
        image2.setTop(1764 / exportHeight);
        image2.setWidth(((2424 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2590 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2484 + addition) / exportWidth);
        image3.setTop(410 / exportHeight);
        image3.setWidth(((4329 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1235 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2484 + addition) / exportWidth);
        image4.setTop(1295 / exportHeight);
        image4.setWidth(((4329 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2590 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_404({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((2426 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2486 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((4911 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((2426 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2486 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((4911 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_405({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((355 + addition) / exportWidth);
        image1.setTop(410 / exportHeight);
        image1.setWidth(((2426 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2486 + addition) / exportWidth);
        image2.setTop(410 / exportHeight);
        image2.setWidth(((4556 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((355 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((2426 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2590 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2486 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((4556 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2590 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_406({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((567 + addition) / exportWidth);
        image1.setTop(282 / exportHeight);
        image1.setWidth(((1752 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1812 + addition) / exportWidth);
        image2.setTop(282 / exportHeight);
        image2.setWidth(((4343 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((567 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((3098 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2718 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((3158 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((4343 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2718 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_407({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((459 + addition) / exportWidth);
        image1.setTop(375 / exportHeight);
        image1.setWidth(((2425 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2485 + addition) / exportWidth);
        image2.setTop(375 / exportHeight);
        image2.setWidth(((4451 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((459 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((2425 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2624 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2485 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((4451 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2624 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_408({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((568 + addition) / exportWidth);
        image1.setTop(282 / exportHeight);
        image1.setWidth(((3100 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((3160 + addition) / exportWidth);
        image2.setTop(282 / exportHeight);
        image2.setWidth(((4344 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((568 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1753 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2718 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1813 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((4344 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2718 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_409({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1726 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1786 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3512 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1726 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1786 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((3512 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_412({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((699 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((2428 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1209 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2488 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((4212 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1740 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2488 + addition) / exportWidth);
        image3.setTop(1800 / exportHeight);
        image3.setWidth(((4212 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2699 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((699 + addition) / exportWidth);
        image4.setTop(1269 / exportHeight);
        image4.setWidth(((2428 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_413({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(281 / exportHeight);
        image1.setWidth(((1494 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1554 + addition) / exportWidth);
        image2.setTop(281 / exportHeight);
        image2.setWidth(((3049 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1494 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2719 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1554 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((3049 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2719 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_414({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1603 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((3236 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1052 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1603 + addition) / exportWidth);
        image2.setTop(1112 / exportHeight);
        image2.setWidth(((3236 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((3000 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3296 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1889 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((3296 + addition) / exportWidth);
        image4.setTop(1949 / exportHeight);
        image4.setWidth(((4911 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    layout_bl_501({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((421 + addition) / exportWidth);
        image1.setTop(360 / exportHeight);
        image1.setWidth(((3112 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1715 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((3172 + addition) / exportWidth);
        image2.setTop(360 / exportHeight);
        image2.setWidth(((4491 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1715 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((421 + addition) / exportWidth);
        image3.setTop(1775 / exportHeight);
        image3.setWidth(((1736 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2639 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1796 + addition) / exportWidth);
        image4.setTop(1775 / exportHeight);
        image4.setWidth(((3112 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2639 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((3172 + addition) / exportWidth);
        image5.setTop(1775 / exportHeight);
        image5.setWidth(((4491 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2639 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_502({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1412 + addition) / exportWidth);
        image1.setTop(229 / exportHeight);
        image1.setWidth(((2742 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1258 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1412 + addition) / exportWidth);
        image2.setTop(1314 / exportHeight);
        image2.setWidth(((2742 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2770 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2798 + addition) / exportWidth);
        image3.setTop(229 / exportHeight);
        image3.setWidth(((4609 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1041 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2798 + addition) / exportWidth);
        image4.setTop(1097 / exportHeight);
        image4.setWidth(((4609 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1902 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2798 + addition) / exportWidth);
        image5.setTop(1958 / exportHeight);
        image5.setWidth(((4609 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2770 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_503({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1446 + addition) / exportWidth);
        image1.setTop(218 / exportHeight);
        image1.setWidth(((4579 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1114 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1446 + addition) / exportWidth);
        image2.setTop(1168 / exportHeight);
        image2.setWidth(((2999 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1827 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3052 + addition) / exportWidth);
        image3.setTop(1168 / exportHeight);
        image3.setWidth(((4579 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1827 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1446 + addition) / exportWidth);
        image4.setTop(1882 / exportHeight);
        image4.setWidth(((4579 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2778 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        // const image5 = new CollageInfo();
        // image5.setLeft((2635 + addition) / exportWidth);
        // image5.setTop(1537 / exportHeight);
        // image5.setWidth(((3436 + addition) / exportWidth) - image5.getLeft());
        // image5.setHeight((2325 / exportHeight) - image5.getTop());
        // collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_504({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1069 + addition) / exportWidth);
        image1.setTop(168 / exportHeight);
        image1.setWidth(((2632 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1068 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2699 + addition) / exportWidth);
        image2.setTop(297 / exportHeight);
        image2.setWidth(((3913 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1068 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((685 + addition) / exportWidth);
        image3.setTop(1134 / exportHeight);
        image3.setWidth(((2632 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1995 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2699 + addition) / exportWidth);
        image4.setTop(1134 / exportHeight);
        image4.setWidth(((4226 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2669 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1154 + addition) / exportWidth);
        image5.setTop(2061 / exportHeight);
        image5.setWidth(((2632 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2831 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_505({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((657 + addition) / exportWidth);
        image1.setTop(375 / exportHeight);
        image1.setWidth(((1825 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1469 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((657 + addition) / exportWidth);
        image2.setTop(1529 / exportHeight);
        image2.setWidth(((1825 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2624 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1885 + addition) / exportWidth);
        image3.setTop(375 / exportHeight);
        image3.setWidth(((3027 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2624 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((3087 + addition) / exportWidth);
        image4.setTop(375 / exportHeight);
        image4.setWidth(((4254 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1470 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((3087 + addition) / exportWidth);
        image5.setTop(1530 / exportHeight);
        image5.setWidth(((4254 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2624 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_506({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((671 + addition) / exportWidth);
        image1.setTop(380 / exportHeight);
        image1.setWidth(((2222 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2619 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2282 + addition) / exportWidth);
        image2.setTop(380 / exportHeight);
        image2.setWidth(((3228 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3288 + addition) / exportWidth);
        image3.setTop(380 / exportHeight);
        image3.setWidth(((4241 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1470 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2282 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((3228 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2619 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((3288 + addition) / exportWidth);
        image5.setTop(1530 / exportHeight);
        image5.setWidth(((4241 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2619 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_507({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1223 + addition) / exportWidth);
        image1.setTop(331 / exportHeight);
        image1.setWidth(((2426 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1867 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2486 + addition) / exportWidth);
        image2.setTop(331 / exportHeight);
        image2.setWidth(((3688 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1072 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2486 + addition) / exportWidth);
        image3.setTop(1132 / exportHeight);
        image3.setWidth(((3688 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1867 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1223 + addition) / exportWidth);
        image4.setTop(1927 / exportHeight);
        image4.setWidth(((2426 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2668 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2486 + addition) / exportWidth);
        image5.setTop(1927 / exportHeight);
        image5.setWidth(((3688 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2668 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_508({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((2452 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((962 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(1022 / exportHeight);
        image2.setWidth(((2452 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1978 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(2038 / exportHeight);
        image3.setWidth(((2452 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2512 + addition) / exportWidth);
        image4.setTop(0 / exportHeight);
        image4.setWidth(((4911 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1681 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2512 + addition) / exportWidth);
        image5.setTop(1741 / exportHeight);
        image5.setWidth(((4911 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((3000 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    layout_bl_601({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1346 + addition) / exportWidth);
        image1.setTop(292 / exportHeight);
        image1.setWidth(((2282 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2342 + addition) / exportWidth);
        image2.setTop(292 / exportHeight);
        image2.setWidth(((3276 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3336 + addition) / exportWidth);
        image3.setTop(292 / exportHeight);
        image3.setWidth(((4272 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1470 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1346 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((2282 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2707 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2342 + addition) / exportWidth);
        image5.setTop(1530 / exportHeight);
        image5.setWidth(((3276 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2707 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3336 + addition) / exportWidth);
        image6.setTop(1530 / exportHeight);
        image6.setWidth(((4272 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2707 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_602({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((869 + addition) / exportWidth);
        image1.setTop(332 / exportHeight);
        image1.setWidth(((2008 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2068 + addition) / exportWidth);
        image2.setTop(332 / exportHeight);
        image2.setWidth(((2842 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1073 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2902 + addition) / exportWidth);
        image3.setTop(332 / exportHeight);
        image3.setWidth(((4042 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1470 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((869 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((2008 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2667 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2068 + addition) / exportWidth);
        image5.setTop(1133 / exportHeight);
        image5.setWidth(((2842 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2667 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2902 + addition) / exportWidth);
        image6.setTop(1530 / exportHeight);
        image6.setWidth(((4042 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2667 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_606({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((921 + addition) / exportWidth);
        image1.setTop(390 / exportHeight);
        image1.setWidth(((1957 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1427 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2101 + addition) / exportWidth);
        image2.setTop(381 / exportHeight);
        image2.setWidth(((2799 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1039 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2936 + addition) / exportWidth);
        image3.setTop(381 / exportHeight);
        image3.setWidth(((3991 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1436 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((921 + addition) / exportWidth);
        image4.setTop(1574 / exportHeight);
        image4.setWidth(((1957 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2610 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2102 + addition) / exportWidth);
        image5.setTop(1176 / exportHeight);
        image5.setWidth(((2798 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2617 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2940 + addition) / exportWidth);
        image6.setTop(1572 / exportHeight);
        image6.setWidth(((3986 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2618 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_608({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1599 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1115 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1659 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3253 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1115 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3313 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1115 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1884 / exportHeight);
        image4.setWidth(((1599 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1659 + addition) / exportWidth);
        image5.setTop(1884 / exportHeight);
        image5.setWidth(((3253 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((3000 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3313 + addition) / exportWidth);
        image6.setTop(1884 / exportHeight);
        image6.setWidth(((4911 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_610({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(675 / exportHeight);
        image1.setWidth(((1599 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1715 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1659 + addition) / exportWidth);
        image2.setTop(675 / exportHeight);
        image2.setWidth(((3253 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1715 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3313 + addition) / exportWidth);
        image3.setTop(675 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1715 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1775 / exportHeight);
        image4.setWidth(((1599 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2814 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1659 + addition) / exportWidth);
        image5.setTop(1775 / exportHeight);
        image5.setWidth(((3253 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2814 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3313 + addition) / exportWidth);
        image6.setTop(1775 / exportHeight);
        image6.setWidth(((4911 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2814 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_611({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(325 / exportHeight);
        image1.setWidth(((1604 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1403 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1664 + addition) / exportWidth);
        image2.setTop(325 / exportHeight);
        image2.setWidth(((3247 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1403 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3307 + addition) / exportWidth);
        image3.setTop(325 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1403 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1685 / exportHeight);
        image4.setWidth(((1604 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2763 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1664 + addition) / exportWidth);
        image5.setTop(1685 / exportHeight);
        image5.setWidth(((3247 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2763 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3307 + addition) / exportWidth);
        image6.setTop(1685 / exportHeight);
        image6.setWidth(((4911 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2763 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_613({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1004 + addition) / exportWidth);
        image1.setTop(187 / exportHeight);
        image1.setWidth(((2426 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1024 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1004 + addition) / exportWidth);
        image2.setTop(1084 / exportHeight);
        image2.setWidth(((2426 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1915 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1004 + addition) / exportWidth);
        image3.setTop(1975 / exportHeight);
        image3.setWidth(((2426 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2812 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2486 + addition) / exportWidth);
        image4.setTop(187 / exportHeight);
        image4.setWidth(((3907 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1024 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2486 + addition) / exportWidth);
        image5.setTop(1084 / exportHeight);
        image5.setWidth(((3907 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1915 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2486 + addition) / exportWidth);
        image6.setTop(1975 / exportHeight);
        image6.setWidth(((3907 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2812 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_614({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1598 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1117 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1658 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3252 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1822 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3312 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1121 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1177 / exportHeight);
        image4.setWidth(((1598 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1658 + addition) / exportWidth);
        image5.setTop(1882 / exportHeight);
        image5.setWidth(((3252 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((3000 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3312 + addition) / exportWidth);
        image6.setTop(1181 / exportHeight);
        image6.setWidth(((4911 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    layout_bl_701({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((2369 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1982 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2429 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3372 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((795 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3432 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((795 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((2429 + addition) / exportWidth);
        image4.setTop(855 / exportHeight);
        image4.setWidth(((4911 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1982 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((0 + addition) / exportWidth);
        image5.setTop(2042 / exportHeight);
        image5.setWidth(((1633 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((3000 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1693 + addition) / exportWidth);
        image6.setTop(2042 / exportHeight);
        image6.setWidth(((3338 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((3398 + addition) / exportWidth);
        image7.setTop(2042 / exportHeight);
        image7.setWidth(((4911 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    layout_bl_702({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((3254 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1141 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((3314 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((4911 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1141 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1201 / exportHeight);
        image3.setWidth(((1601 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1808 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1661 + addition) / exportWidth);
        image4.setTop(1201 / exportHeight);
        image4.setWidth(((3254 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1808 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((3314 + addition) / exportWidth);
        image5.setTop(1201 / exportHeight);
        image5.setWidth(((4911 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1808 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(1868 / exportHeight);
        image6.setWidth(((1601 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1661 + addition) / exportWidth);
        image7.setTop(1868 / exportHeight);
        image7.setWidth(((4911 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    layout_bl_801({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1812 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((962 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1872 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3038 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((962 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3098 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((962 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1022 / exportHeight);
        image4.setWidth(((1812 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1977 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((3098 + addition) / exportWidth);
        image5.setTop(1022 / exportHeight);
        image5.setWidth(((4911 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1977 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(2037 / exportHeight);
        image6.setWidth(((1812 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1872 + addition) / exportWidth);
        image7.setTop(2037 / exportHeight);
        image7.setWidth(((3038 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((3098 + addition) / exportWidth);
        image8.setTop(2037 / exportHeight);
        image8.setWidth(((4911 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    layout_bl_802({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((1154 + addition) / exportWidth);
        image1.setTop(203 / exportHeight);
        image1.setWidth(((1978 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1027 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2038 + addition) / exportWidth);
        image2.setTop(203 / exportHeight);
        image2.setWidth(((2863 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1027 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2923 + addition) / exportWidth);
        image3.setTop(203 / exportHeight);
        image3.setWidth(((3747 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1027 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1154 + addition) / exportWidth);
        image4.setTop(1087 / exportHeight);
        image4.setWidth(((1978 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1912 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2923 + addition) / exportWidth);
        image5.setTop(1087 / exportHeight);
        image5.setWidth(((3747 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1912 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1154 + addition) / exportWidth);
        image6.setTop(1972 / exportHeight);
        image6.setWidth(((1978 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2797 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((2038 + addition) / exportWidth);
        image7.setTop(1972 / exportHeight);
        image7.setWidth(((2863 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2797 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((2923 + addition) / exportWidth);
        image8.setTop(1972 / exportHeight);
        image8.setWidth(((3747 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((2797 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    layout_bl_803({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((3254 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1141 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((3314 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((4911 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1141 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1201 / exportHeight);
        image3.setWidth(((1601 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1808 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1661 + addition) / exportWidth);
        image4.setTop(1201 / exportHeight);
        image4.setWidth(((3254 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1808 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((3314 + addition) / exportWidth);
        image5.setTop(1201 / exportHeight);
        image5.setWidth(((4911 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1808 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(1868 / exportHeight);
        image6.setWidth(((1601 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1661 + addition) / exportWidth);
        image7.setTop(1868 / exportHeight);
        image7.setWidth(((3254 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((3314 + addition) / exportWidth);
        image8.setTop(1868 / exportHeight);
        image8.setWidth(((4911 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    layout_bl_901({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1601 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1041 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1661 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3259 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((793 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3319 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1041 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1101 / exportHeight);
        image4.setWidth(((1601 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1885 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1657 + addition) / exportWidth);
        image5.setTop(846 / exportHeight);
        image5.setWidth(((3263 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2150 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3319 + addition) / exportWidth);
        image6.setTop(1101 / exportHeight);
        image6.setWidth(((4911 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1885 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((0 + addition) / exportWidth);
        image7.setTop(1945 / exportHeight);
        image7.setWidth(((1601 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((1661 + addition) / exportWidth);
        image8.setTop(2202 / exportHeight);
        image8.setWidth(((3259 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((3319 + addition) / exportWidth);
        image9.setTop(1945 / exportHeight);
        image9.setWidth(((4911 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((3000 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
    layout_bl_902({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 4911 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1599 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((963 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1659 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3253 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((963 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((3313 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((4911 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((963 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1023 / exportHeight);
        image4.setWidth(((1599 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1977 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1659 + addition) / exportWidth);
        image5.setTop(1023 / exportHeight);
        image5.setWidth(((3253 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1977 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((3313 + addition) / exportWidth);
        image6.setTop(1023 / exportHeight);
        image6.setWidth(((4911 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1977 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((0 + addition) / exportWidth);
        image7.setTop(2037 / exportHeight);
        image7.setWidth(((1599 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((1659 + addition) / exportWidth);
        image8.setTop(2037 / exportHeight);
        image8.setWidth(((3253 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((3313 + addition) / exportWidth);
        image9.setTop(2037 / exportHeight);
        image9.setWidth(((4911 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((3000 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
    layout_bs_cl_106({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(3749 / exportWidth);
        collageInfo1.setTop(750 / exportHeight);
        collageInfo1.setWidth((5249 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    layout_bs_cl_107({ exportWidth = 0, exportHeight = 0 } = {}) {

        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(750 / exportWidth);
        collageInfo1.setTop(750 / exportHeight);
        collageInfo1.setWidth((2249 / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2249 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfo1.isImage = true;
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_txt({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const collageInfoList = [];
        const addition = isRightPage ? 3000 : 0;
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((600 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfo1.setIsText(true);
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_101({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(862 / exportHeight);
        collageInfo1
            .setWidth(((3000 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2549 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_102({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1687 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_103({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1312 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3000 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_105({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1
            .setWidth(((2700 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_106({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(1200 / exportHeight);
        collageInfo1
            .setWidth(((2699 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2549 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_111({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((450 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((1800 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2700 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_112({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1200 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2550 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2700 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_113({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3000 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_114({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((150 + addition) / exportWidth);
        collageInfo1.setTop(150 / exportHeight);
        collageInfo1
            .setWidth(((2849 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2849 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_115({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2700 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2700 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_116({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((600 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_117({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3000 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2099 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_118({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(900 / exportHeight);
        collageInfo1
            .setWidth(((3000 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);
        return collageInfoList;

    },
    bs_119({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1
            .setWidth(((2700 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1157 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((300 + addition) / exportWidth);
        collageInfo2.setTop(1200 / exportHeight);
        collageInfo2
            .setWidth(((2700 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2549 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    bs_120({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(450 / exportHeight);
        collageInfo1
            .setWidth(((2700 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1800 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((300 + addition) / exportWidth);
        collageInfo2.setTop(1842 / exportHeight);
        collageInfo2
            .setWidth(((2700 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2549 / exportHeight) - collageInfo2.getTop());
        collageInfo2.isText = true;
        collageInfo2.fontName = "TimesNewRoman";
        collageInfo2.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo2);
        return collageInfoList;

    },
    bs_layout_119fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((750 + additionWidth) / exportWidth);
        collageInfo1.setTop((527 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2250 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((2026 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((450 + additionWidth) / exportWidth);
        collageInfo2.setTop((2430 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2550 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2565 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_layout_120fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((450 + additionWidth) / exportWidth);
        collageInfo2.setTop((383 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2550 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((517 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((900 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3000 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((3000 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    bs_layout_121fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3000 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1800 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((450 + additionWidth) / exportWidth);
        collageInfo2.setTop((2332 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2550 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2467 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_layout_122fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((450 + additionWidth) / exportWidth);
        collageInfo1.setTop((455 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2549 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((1955 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((450 + additionWidth) / exportWidth);
        collageInfo2.setTop((2410 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2550 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2544 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfo2.setIsImage(false);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_layout_123fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((0 + additionWidth) / exportWidth);
        collageInfo1.setTop((0 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((3000 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((3000 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    bs_layout_124fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;
        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft((825 + additionWidth) / exportWidth);
        collageInfo1.setTop((825 + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            ((2175 + additionWidth) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight(
            ((2175 + additionHeight) / exportHeight) - collageInfo1.getTop());
        collageInfo1.isCircle = true;
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    bs_layout_127_fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();
        collageInfo1.setLeft(((isExport ? 452 : 900) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 303 : 450) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 2547 : 2000) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 1798 : 1650) + additionHeight) / exportHeight) -
            collageInfo1.getTop());
        collageInfo1.setDisplayLeft(((900) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((450) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((2000) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((1798) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((148 + additionWidth) / exportWidth);
        collageInfo2.setTop((1798 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2852 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2854 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_layout_txt_f_fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((148 + additionWidth) / exportWidth);
        collageInfo2.setTop((288 + additionHeight) / exportHeight);
        collageInfo2.setWidth(
            ((2852 + additionWidth) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight(
            ((2711 + additionHeight) / exportHeight) - collageInfo2.getTop());
        collageInfo2.setIsText(true);
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    cover_bs_layout_127_fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3000 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        const collageInfo1 = new CollageInfo();

        //to get user's actual image coordinates during display and to get white area during export
        collageInfo1.setLeft(((isExport ? 750 : 975) + additionWidth) / exportWidth);
        collageInfo1.setTop(((isExport ? 750 : 975) + additionHeight) / exportHeight);
        collageInfo1.setWidth(
            (((isExport ? 2250 : 2025) + additionWidth) / exportWidth) -
            collageInfo1.getLeft());
        collageInfo1.setHeight(
            (((isExport ? 2250 : 2025) + additionHeight) / exportHeight) -
            collageInfo1.getTop());

        //to get user's actual image coordinates during export
        collageInfo1.setDisplayLeft(((975) + additionWidth) / exportWidth);
        collageInfo1.setDisplayTop(((975) + additionHeight) / exportHeight);
        collageInfo1.setDisplayWidth(
            (((2025) + additionWidth) / exportWidth) - collageInfo1.getDisplayLeft());
        collageInfo1.setDisplayHeight((((2025) + additionHeight) / exportHeight) -
            collageInfo1.getDisplayTop());
        collageInfoList.push(collageInfo1);

        return collageInfoList;

    },
    cover_bs_layout_plain_f_fr({ exportWidth = 3000,
        exportHeight = 3000,
        isRightPage = false,
        isExport = false,
        spineSize = 0,
        rightLeftMargin = 0,
        topBottomMargin = 0 } = {}) {

        const additionWidth = isRightPage ? (3540 + spineSize + rightLeftMargin) : 0;
        const additionHeight = isExport ? topBottomMargin : 0;

        const collageInfoList = [];

        return collageInfoList;

    },
    bs_201({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((345 + addition) / exportWidth);
        collageInfo1.setTop(658 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2658 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(658 / exportHeight);
        collageInfo2
            .setWidth(((2654 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2658 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_202({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((345 + addition) / exportWidth);
        collageInfo1.setTop(1111 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2658 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(658 / exportHeight);
        collageInfo2
            .setWidth(((2654 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2658 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_203({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((500 + addition) / exportWidth);
        collageInfo1.setTop(345 / exportHeight);
        collageInfo1
            .setWidth(((2500 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((500 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((2500 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2654 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_204({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((750 + addition) / exportWidth);
        collageInfo1.setTop(396 / exportHeight);
        collageInfo1
            .setWidth(((2250 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1896 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((750 + addition) / exportWidth);
        collageInfo2.setTop(1956 / exportHeight);
        collageInfo2
            .setWidth(((2250 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2603 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_205({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((345 + addition) / exportWidth);
        collageInfo1.setTop(345 / exportHeight);
        collageInfo1
            .setWidth(((2344 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((345 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((1892 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2654 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_206({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((300 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((1500 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1500 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1500 + addition) / exportWidth);
        collageInfo2.setTop(1500 / exportHeight);
        collageInfo2
            .setWidth(((2700 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2700 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_207({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((3000 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((0 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((3000 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_208({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((345 + addition) / exportWidth);
        collageInfo1.setTop(740 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2740 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(260 / exportHeight);
        collageInfo2
            .setWidth(((2654 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2260 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_210({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((1500 + addition) / exportWidth);
        collageInfo1.setTop(300 / exportHeight);
        collageInfo1
            .setWidth(((2700 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1500 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((300 + addition) / exportWidth);
        collageInfo2.setTop(1500 / exportHeight);
        collageInfo2
            .setWidth(((1500 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2700 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_212({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((270 + addition) / exportWidth);
        collageInfo1.setTop(1500 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2700 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(1500 / exportHeight);
        collageInfo2
            .setWidth(((2730 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2700 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_213({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((900 + addition) / exportWidth);
        collageInfo1.setTop(270 / exportHeight);
        collageInfo1
            .setWidth(((2100 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((900 + addition) / exportWidth);
        collageInfo2.setTop(1530 / exportHeight);
        collageInfo2
            .setWidth(((2100 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2730 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_214({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((3000 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        return collageInfoList;

    },
    bs_215({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((270 + addition) / exportWidth);
        collageInfo1.setTop(357 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1879 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(357 / exportHeight);
        collageInfo2
            .setWidth(((2729 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1879 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((270 + addition) / exportWidth);
        collageInfo3.setTop(1936 / exportHeight);
        collageInfo3
            .setWidth(((2729 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2643 / exportHeight) - collageInfo3.getTop());
        collageInfo3.isText = true;
        collageInfo3.fontName = "TimesNewRoman";
        collageInfo3.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_216({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((270 + addition) / exportWidth);
        collageInfo1.setTop(357 / exportHeight);
        collageInfo1
            .setWidth(((2729 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1064 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((270 + addition) / exportWidth);
        collageInfo2.setTop(1120 / exportHeight);
        collageInfo2
            .setWidth(((1470 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2643 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1530 + addition) / exportWidth);
        collageInfo3.setTop(1120 / exportHeight);
        collageInfo3
            .setWidth(((2729 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2643 / exportHeight) - collageInfo3.getTop());

        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_217({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((232 + addition) / exportWidth);
        collageInfo1.setTop(232 / exportHeight);
        collageInfo1
            .setWidth(((1445 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1445 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1500 + addition) / exportWidth);
        collageInfo2.setTop(187 / exportHeight);
        collageInfo2
            .setWidth(((2812 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1500 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((187 + addition) / exportWidth);
        collageInfo3.setTop(1500 / exportHeight);
        collageInfo3
            .setWidth(((1500 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2812 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        const collageInfo4 = new CollageInfo();
        collageInfo4.setIsRight(isRightPage);
        collageInfo4.setLeft((1544 + addition) / exportWidth);
        collageInfo4.setTop(1544 / exportHeight);
        collageInfo4
            .setWidth(((2768 + addition) / exportWidth) - collageInfo4.getLeft());
        collageInfo4.setHeight((2768 / exportHeight) - collageInfo4.getTop());
        collageInfo4.isText = true;
        collageInfo4.fontName = "TimesNewRoman";
        collageInfo4.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo4);

        return collageInfoList;

    },
    bs_218({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((152 + addition) / exportWidth);
        collageInfo2.setTop(152 / exportHeight);
        collageInfo2
            .setWidth(((2851 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1354 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((152 + addition) / exportWidth);
        collageInfo1.setTop(1399 / exportHeight);
        collageInfo1
            .setWidth(((2851 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1600 / exportHeight) - collageInfo1.getTop());
        collageInfo1.isText = true;
        collageInfo1.fontName = "TimesNewRoman";
        collageInfo1.fontSizeInPoints = 20;
        collageInfoList.push(collageInfo1);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((152 + addition) / exportWidth);
        collageInfo3.setTop(1649 / exportHeight);
        collageInfo3
            .setWidth(((2851 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2851 / exportHeight) - collageInfo3.getTop());

        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_301({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((213 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1900 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1960 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((2787 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1470 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1960 + addition) / exportWidth);
        collageInfo3.setTop(1530 / exportHeight);
        collageInfo3
            .setWidth(((2787 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((3000 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_302({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((213 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1040 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1470 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1100 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((2787 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((3000 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((213 + addition) / exportWidth);
        collageInfo3.setTop(1530 / exportHeight);
        collageInfo3
            .setWidth(((1040 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((3000 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_303({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((270 + addition) / exportWidth);
        collageInfo1.setTop(233 / exportHeight);
        collageInfo1
            .setWidth(((1470 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1433 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1530 + addition) / exportWidth);
        collageInfo2.setTop(233 / exportHeight);
        collageInfo2
            .setWidth(((2729 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1433 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((270 + addition) / exportWidth);
        collageInfo3.setTop(1493 / exportHeight);
        collageInfo3
            .setWidth(((1470 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2693 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_304({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((600 + addition) / exportWidth);
        collageInfo1.setTop(315 / exportHeight);
        collageInfo1
            .setWidth(((2400 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1065 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((600 + addition) / exportWidth);
        collageInfo2.setTop(1125 / exportHeight);
        collageInfo2
            .setWidth(((2400 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1875 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((600 + addition) / exportWidth);
        collageInfo3.setTop(1935 / exportHeight);
        collageInfo3
            .setWidth(((2400 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2684 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_305({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((315 + addition) / exportWidth);
        collageInfo1.setTop(600 / exportHeight);
        collageInfo1
            .setWidth(((1065 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((2400 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1125 + addition) / exportWidth);
        collageInfo2.setTop(600 / exportHeight);
        collageInfo2
            .setWidth(((1875 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((2400 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1935 + addition) / exportWidth);
        collageInfo3.setTop(600 / exportHeight);
        collageInfo3
            .setWidth(((2684 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2400 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_306({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((240 + addition) / exportWidth);
        collageInfo1.setTop(248 / exportHeight);
        collageInfo1
            .setWidth(((1740 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((1747 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1800 + addition) / exportWidth);
        collageInfo2.setTop(248 / exportHeight);
        collageInfo2
            .setWidth(((2550 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((998 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((240 + addition) / exportWidth);
        collageInfo3.setTop(1807 / exportHeight);
        collageInfo3
            .setWidth(((990 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2557 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_307({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((450 + addition) / exportWidth);
        collageInfo1.setTop(240 / exportHeight);
        collageInfo1
            .setWidth(((1200 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((990 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1260 + addition) / exportWidth);
        collageInfo2.setTop(240 / exportHeight);
        collageInfo2
            .setWidth(((2760 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1740 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((2010 + addition) / exportWidth);
        collageInfo3.setTop(1800 / exportHeight);
        collageInfo3
            .setWidth(((2760 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((2550 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_309({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const collageInfo1 = new CollageInfo();
        collageInfo1.setIsRight(isRightPage);
        collageInfo1.setLeft((0 + addition) / exportWidth);
        collageInfo1.setTop(0 / exportHeight);
        collageInfo1
            .setWidth(((1687 + addition) / exportWidth) - collageInfo1.getLeft());
        collageInfo1.setHeight((3000 / exportHeight) - collageInfo1.getTop());
        collageInfoList.push(collageInfo1);

        const collageInfo2 = new CollageInfo();
        collageInfo2.setIsRight(isRightPage);
        collageInfo2.setLeft((1747 + addition) / exportWidth);
        collageInfo2.setTop(0 / exportHeight);
        collageInfo2
            .setWidth(((3000 + addition) / exportWidth) - collageInfo2.getLeft());
        collageInfo2.setHeight((1470 / exportHeight) - collageInfo2.getTop());
        collageInfoList.push(collageInfo2);

        const collageInfo3 = new CollageInfo();
        collageInfo3.setIsRight(isRightPage);
        collageInfo3.setLeft((1747 + addition) / exportWidth);
        collageInfo3.setTop(1530 / exportHeight);
        collageInfo3
            .setWidth(((3000 + addition) / exportWidth) - collageInfo3.getLeft());
        collageInfo3.setHeight((3000 / exportHeight) - collageInfo3.getTop());
        collageInfoList.push(collageInfo3);

        return collageInfoList;

    },
    bs_310({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1252 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1530 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((3000 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1252 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(1312 / exportHeight);
        image3.setWidth(((3000 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    bs_311({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((270 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2700 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1530 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2730 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1500 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1530 + addition) / exportWidth);
        image3.setTop(1560 / exportHeight);
        image3.setWidth(((2730 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2310 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    bs_312({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((225 + addition) / exportWidth);
        image1.setTop(225 / exportHeight);
        image1.setWidth(((1075 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1075 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1075 + addition) / exportWidth);
        image2.setTop(1075 / exportHeight);
        image2.setWidth(((1925 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1925 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1925 + addition) / exportWidth);
        image3.setTop(1925 / exportHeight);
        image3.setWidth(((2774 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2774 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    bs_313({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((270 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1500 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((270 + addition) / exportWidth);
        image2.setTop(1560 / exportHeight);
        image2.setWidth(((1470 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2310 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1530 + addition) / exportWidth);
        image3.setTop(300 / exportHeight);
        image3.setWidth(((2730 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2700 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        return collageInfoList;

    },
    bs_314({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((188 + addition) / exportWidth);
        image1.setTop(188 / exportHeight);
        image1.setWidth(((1761 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1761 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1798 + addition) / exportWidth);
        image2.setTop(188 / exportHeight);
        image2.setWidth(((2811 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1761 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((188 + addition) / exportWidth);
        image3.setTop(1798 / exportHeight);
        image3.setWidth(((1761 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2811 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1798 + addition) / exportWidth);
        image4.setTop(1798 / exportHeight);
        image4.setWidth(((2811 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2811 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_315({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((188 + addition) / exportWidth);
        image1.setTop(188 / exportHeight);
        image1.setWidth(((1201 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1761 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1238 + addition) / exportWidth);
        image2.setTop(188 / exportHeight);
        image2.setWidth(((2811 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1761 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((188 + addition) / exportWidth);
        image3.setTop(1798 / exportHeight);
        image3.setWidth(((1201 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2811 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1238 + addition) / exportWidth);
        image4.setTop(1798 / exportHeight);
        image4.setWidth(((2811 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2811 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_316({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((187 + addition) / exportWidth);
        image1.setTop(187 / exportHeight);
        image1.setWidth(((1476 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2812 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1523 + addition) / exportWidth);
        image2.setTop(187 / exportHeight);
        image2.setWidth(((2812 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1379 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1523 + addition) / exportWidth);
        image3.setTop(1426 / exportHeight);
        image3.setWidth(((2812 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2265 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1523 + addition) / exportWidth);
        image4.setTop(2320 / exportHeight);
        image4.setWidth(((2812 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2812 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_317({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((187 + addition) / exportWidth);
        image1.setTop(187 / exportHeight);
        image1.setWidth(((1476 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1476 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1523 + addition) / exportWidth);
        image2.setTop(187 / exportHeight);
        image2.setWidth(((2812 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1476 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((187 + addition) / exportWidth);
        image3.setTop(1523 / exportHeight);
        image3.setWidth(((1476 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2812 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1523 + addition) / exportWidth);
        image4.setTop(1523 / exportHeight);
        image4.setWidth(((2812 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2812 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_318({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((187 + addition) / exportWidth);
        image1.setTop(187 / exportHeight);
        image1.setWidth(((1476 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1476 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1523 + addition) / exportWidth);
        image2.setTop(187 / exportHeight);
        image2.setWidth(((2812 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1476 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((187 + addition) / exportWidth);
        image3.setTop(1523 / exportHeight);
        image3.setWidth(((1476 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2812 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1523 + addition) / exportWidth);
        image4.setTop(1523 / exportHeight);
        image4.setWidth(((2812 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2812 / exportHeight) - image4.getTop());

        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_319({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((188 + addition) / exportWidth);
        image1.setTop(267 / exportHeight);
        image1.setWidth(((1039 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2065 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1086 + addition) / exportWidth);
        image2.setTop(267 / exportHeight);
        image2.setWidth(((1913 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2065 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1960 + addition) / exportWidth);
        image3.setTop(267 / exportHeight);
        image3.setWidth(((2811 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2065 / exportHeight) - image3.getTop());

        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((352 + addition) / exportWidth);
        image4.setTop(2222 / exportHeight);
        image4.setWidth(((2647 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2732 / exportHeight) - image4.getTop());
        image4.isText = true;
        image4.fontName = "TimesNewRoman";
        image4.fontSizeInPoints = 20;
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_401({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((570 + addition) / exportWidth);
        image1.setTop(570 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1530 + addition) / exportWidth);
        image2.setTop(570 / exportHeight);
        image2.setWidth(((2429 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((570 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1470 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2429 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1530 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((2429 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2429 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_402({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((439 + addition) / exportWidth);
        image1.setTop(439 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1770 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1530 + addition) / exportWidth);
        image2.setTop(439 / exportHeight);
        image2.setWidth(((2561 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1170 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((439 + addition) / exportWidth);
        image3.setTop(1830 / exportHeight);
        image3.setWidth(((1470 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2561 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1530 + addition) / exportWidth);
        image4.setTop(1230 / exportHeight);
        image4.setWidth(((2561 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2561 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_403({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((270 + addition) / exportWidth);
        image1.setTop(270 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1530 + addition) / exportWidth);
        image2.setTop(270 / exportHeight);
        image2.setWidth(((2729 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((270 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1470 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2729 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1530 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((2729 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2729 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_404({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((323 + addition) / exportWidth);
        image1.setTop(323 / exportHeight);
        image1.setWidth(((1259 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1259 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1301 + addition) / exportWidth);
        image2.setTop(323 / exportHeight);
        image2.setWidth(((2238 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1259 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((323 + addition) / exportWidth);
        image3.setTop(1301 / exportHeight);
        image3.setWidth(((1259 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2238 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1301 + addition) / exportWidth);
        image4.setTop(1301 / exportHeight);
        image4.setWidth(((2677 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2677 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_405({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((450 + addition) / exportWidth);
        image1.setTop(451 / exportHeight);
        image1.setWidth(((1285 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1286 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1714 + addition) / exportWidth);
        image2.setTop(451 / exportHeight);
        image2.setWidth(((2549 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1286 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((450 + addition) / exportWidth);
        image3.setTop(1713 / exportHeight);
        image3.setWidth(((1285 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2548 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1714 + addition) / exportWidth);
        image4.setTop(1713 / exportHeight);
        image4.setWidth(((2549 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2548 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_406({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((668 + addition) / exportWidth);
        image1.setTop(263 / exportHeight);
        image1.setWidth(((1470 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1530 + addition) / exportWidth);
        image2.setTop(263 / exportHeight);
        image2.setWidth(((2331 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((668 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1470 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2736 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1530 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((2331 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2736 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_407({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((330 + addition) / exportWidth);
        image1.setTop(571 / exportHeight);
        image1.setWidth(((1557 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1423 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1730 + addition) / exportWidth);
        image2.setTop(311 / exportHeight);
        image2.setWidth(((2669 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1423 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((330 + addition) / exportWidth);
        image3.setTop(1576 / exportHeight);
        image3.setWidth(((1269 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2688 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1442 + addition) / exportWidth);
        image4.setTop(1576 / exportHeight);
        image4.setWidth(((2669 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2428 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_408({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1478 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1071 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((300 + addition) / exportWidth);
        image2.setTop(1114 / exportHeight);
        image2.setWidth(((1478 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1885 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1928 / exportHeight);
        image3.setWidth(((1478 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2699 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1521 + addition) / exportWidth);
        image4.setTop(300 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_409({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((2699 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1883 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((300 + addition) / exportWidth);
        image2.setTop(1928 / exportHeight);
        image2.setWidth(((1071 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2699 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1114 + addition) / exportWidth);
        image3.setTop(1928 / exportHeight);
        image3.setWidth(((1885 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2699 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1928 + addition) / exportWidth);
        image4.setTop(1928 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_410({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1478 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1198 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1521 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1198 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1801 / exportHeight);
        image3.setWidth(((1478 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2699 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1521 + addition) / exportWidth);
        image4.setTop(1801 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_411({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((439 + addition) / exportWidth);
        image1.setTop(439 / exportHeight);
        image1.setWidth(((1170 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1230 + addition) / exportWidth);
        image2.setTop(439 / exportHeight);
        image2.setWidth(((2561 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((439 + addition) / exportWidth);
        image3.setTop(1530 / exportHeight);
        image3.setWidth(((1770 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2561 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1830 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((2561 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2561 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_412({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((840 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1740 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1200 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1800 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1200 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((840 + addition) / exportWidth);
        image3.setTop(1260 / exportHeight);
        image3.setWidth(((1740 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2159 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1800 + addition) / exportWidth);
        image4.setTop(1260 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2159 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_413({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1200 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1200 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1260 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2159 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1200 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1260 / exportHeight);
        image3.setWidth(((1200 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2159 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1260 + addition) / exportWidth);
        image4.setTop(1260 / exportHeight);
        image4.setWidth(((2159 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2159 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        return collageInfoList;

    },
    bs_414({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1478 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1198 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1521 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1198 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1257 / exportHeight);
        image3.setWidth(((2699 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1742 / exportHeight) - image3.getTop());
        image3.isText = true;
        image3.fontName = "TimesNewRoman";
        image3.fontSizeInPoints = 20;
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((300 + addition) / exportWidth);
        image4.setTop(1801 / exportHeight);
        image4.setWidth(((1478 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1521 + addition) / exportWidth);
        image5.setTop(1801 / exportHeight);
        image5.setWidth(((2699 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_415({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];

        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((2849 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((750 / exportHeight) - image1.getTop());
        image1.isText = true;
        image1.fontName = "TimesNewRoman";
        image1.fontSizeInPoints = 20;
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((150 + addition) / exportWidth);
        image2.setTop(807 / exportHeight);
        image2.setWidth(((1470 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1800 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1529 + addition) / exportWidth);
        image3.setTop(807 / exportHeight);
        image3.setWidth(((2849 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1800 / exportHeight) - image3.getTop());

        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1857 / exportHeight);
        image4.setWidth(((1470 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2849 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1529 + addition) / exportWidth);
        image5.setTop(1857 / exportHeight);
        image5.setWidth(((2849 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2849 / exportHeight) - image5.getTop());

        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_501({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1507 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1923 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1567 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2849 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1017 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1567 + addition) / exportWidth);
        image3.setTop(1076 / exportHeight);
        image3.setWidth(((2849 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1923 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((150 + addition) / exportWidth);
        image4.setTop(1982 / exportHeight);
        image4.setWidth(((1507 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2849 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1567 + addition) / exportWidth);
        image5.setTop(1982 / exportHeight);
        image5.setWidth(((2849 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2849 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_502({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((2699 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1132 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((300 + addition) / exportWidth);
        image2.setTop(1200 / exportHeight);
        image2.setWidth(((1467 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1916 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1535 + addition) / exportWidth);
        image3.setTop(1200 / exportHeight);
        image3.setWidth(((2699 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1916 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((300 + addition) / exportWidth);
        image4.setTop(1983 / exportHeight);
        image4.setWidth(((1467 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1535 + addition) / exportWidth);
        image5.setTop(1983 / exportHeight);
        image5.setWidth(((2699 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_503({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(771 / exportHeight);
        image1.setWidth(((1009 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1479 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((300 + addition) / exportWidth);
        image2.setTop(1522 / exportHeight);
        image2.setWidth(((1009 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2228 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1045 + addition) / exportWidth);
        image3.setTop(771 / exportHeight);
        image3.setWidth(((1947 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2228 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1990 + addition) / exportWidth);
        image4.setTop(771 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1479 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1990 + addition) / exportWidth);
        image5.setTop(1522 / exportHeight);
        image5.setWidth(((2699 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2228 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_504({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((773 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((2226 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1199 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((773 + addition) / exportWidth);
        image2.setTop(1242 / exportHeight);
        image2.setWidth(((1479 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1949 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1522 + addition) / exportWidth);
        image3.setTop(1242 / exportHeight);
        image3.setWidth(((2226 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1949 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((773 + addition) / exportWidth);
        image4.setTop(1992 / exportHeight);
        image4.setWidth(((1479 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1522 + addition) / exportWidth);
        image5.setTop(1992 / exportHeight);
        image5.setWidth(((2226 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_505({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1506 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1473 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((300 + addition) / exportWidth);
        image2.setTop(1526 / exportHeight);
        image2.setWidth(((1506 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((2699 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1559 + addition) / exportWidth);
        image3.setTop(300 / exportHeight);
        image3.setWidth(((2699 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1071 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1559 + addition) / exportWidth);
        image4.setTop(1123 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1876 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1559 + addition) / exportWidth);
        image5.setTop(1928 / exportHeight);
        image5.setWidth(((2699 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_506({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(274 / exportHeight);
        image1.setWidth(((1907 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((2673 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1950 + addition) / exportWidth);
        image2.setTop(274 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((845 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1950 + addition) / exportWidth);
        image3.setTop(886 / exportHeight);
        image3.setWidth(((2699 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1444 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1950 + addition) / exportWidth);
        image4.setTop(1486 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2058 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1950 + addition) / exportWidth);
        image5.setTop(2101 / exportHeight);
        image5.setWidth(((2699 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2673 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_507({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((960 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((961 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((0 + addition) / exportWidth);
        image2.setTop(1019 / exportHeight);
        image2.setWidth(((960 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1980 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((0 + addition) / exportWidth);
        image3.setTop(2038 / exportHeight);
        image3.setWidth(((960 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1017 + addition) / exportWidth);
        image4.setTop(2038 / exportHeight);
        image4.setWidth(((1977 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2034 + addition) / exportWidth);
        image5.setTop(2038 / exportHeight);
        image5.setWidth(((2994 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((3000 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_508({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((2040 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((3000 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((961 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((2040 + addition) / exportWidth);
        image2.setTop(1019 / exportHeight);
        image2.setWidth(((3000 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1980 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2040 + addition) / exportWidth);
        image3.setTop(2038 / exportHeight);
        image3.setWidth(((3000 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((3000 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1022 + addition) / exportWidth);
        image4.setTop(2038 / exportHeight);
        image4.setWidth(((1982 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((3000 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((0 + addition) / exportWidth);
        image5.setTop(2038 / exportHeight);
        image5.setWidth(((965 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((3000 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        return collageInfoList;

    },
    bs_601({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((427 + addition) / exportWidth);
        image1.setTop(438 / exportHeight);
        image1.setWidth(((1102 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1470 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1162 + addition) / exportWidth);
        image2.setTop(438 / exportHeight);
        image2.setWidth(((1837 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1470 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1897 + addition) / exportWidth);
        image3.setTop(438 / exportHeight);
        image3.setWidth(((2572 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1470 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((427 + addition) / exportWidth);
        image4.setTop(1530 / exportHeight);
        image4.setWidth(((1102 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2561 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1162 + addition) / exportWidth);
        image5.setTop(1530 / exportHeight);
        image5.setWidth(((1837 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2561 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1897 + addition) / exportWidth);
        image6.setTop(1530 / exportHeight);
        image6.setWidth(((2572 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2561 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    bs_603({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((277 + addition) / exportWidth);
        image1.setTop(260 / exportHeight);
        image1.setWidth(((1887 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1869 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1947 + addition) / exportWidth);
        image2.setTop(260 / exportHeight);
        image2.setWidth(((2722 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1034 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1947 + addition) / exportWidth);
        image3.setTop(1094 / exportHeight);
        image3.setWidth(((2722 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1869 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((277 + addition) / exportWidth);
        image4.setTop(1930 / exportHeight);
        image4.setWidth(((1052 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2705 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1112 + addition) / exportWidth);
        image5.setTop(1930 / exportHeight);
        image5.setWidth(((1887 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2705 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1947 + addition) / exportWidth);
        image6.setTop(1929 / exportHeight);
        image6.setWidth(((2722 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2704 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    bs_605({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1887 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1075 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1925 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1075 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1112 / exportHeight);
        image3.setWidth(((1887 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1887 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1925 + addition) / exportWidth);
        image4.setTop(1112 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1887 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((300 + addition) / exportWidth);
        image5.setTop(1925 / exportHeight);
        image5.setWidth(((1887 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1925 + addition) / exportWidth);
        image6.setTop(1925 / exportHeight);
        image6.setWidth(((2699 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2699 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    bs_606({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1049 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1071 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1091 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1071 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((300 + addition) / exportWidth);
        image3.setTop(1114 / exportHeight);
        image3.setWidth(((1906 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1885 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1948 + addition) / exportWidth);
        image4.setTop(1114 / exportHeight);
        image4.setWidth(((2699 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1885 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((300 + addition) / exportWidth);
        image5.setTop(1928 / exportHeight);
        image5.setWidth(((1049 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1091 + addition) / exportWidth);
        image6.setTop(1928 / exportHeight);
        image6.setWidth(((2699 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2699 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    bs_609({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((1907 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1471 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1950 + addition) / exportWidth);
        image2.setTop(300 / exportHeight);
        image2.setWidth(((2699 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((872 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1950 + addition) / exportWidth);
        image3.setTop(912 / exportHeight);
        image3.setWidth(((2699 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1471 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((300 + addition) / exportWidth);
        image4.setTop(1513 / exportHeight);
        image4.setWidth(((1907 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1950 + addition) / exportWidth);
        image5.setTop(1513 / exportHeight);
        image5.setWidth(((2699 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2085 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1950 + addition) / exportWidth);
        image6.setTop(2127 / exportHeight);
        image6.setWidth(((2699 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2699 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    bs_610({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((300 + addition) / exportWidth);
        image1.setTop(300 / exportHeight);
        image1.setWidth(((2699 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1162 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((300 + addition) / exportWidth);
        image2.setTop(1205 / exportHeight);
        image2.setWidth(((1478 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1885 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((1521 + addition) / exportWidth);
        image3.setTop(1205 / exportHeight);
        image3.setWidth(((2699 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1885 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((300 + addition) / exportWidth);
        image4.setTop(1928 / exportHeight);
        image4.setWidth(((1071 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2699 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1114 + addition) / exportWidth);
        image5.setTop(1928 / exportHeight);
        image5.setWidth(((1885 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2699 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1928 + addition) / exportWidth);
        image6.setTop(1928 / exportHeight);
        image6.setWidth(((2699 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2699 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        return collageInfoList;

    },
    bs_701({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((148 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1929 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1024 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1977 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2851 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1024 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((148 + addition) / exportWidth);
        image3.setTop(1072 / exportHeight);
        image3.setWidth(((1017 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1946 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1065 + addition) / exportWidth);
        image4.setTop(1072 / exportHeight);
        image4.setWidth(((1934 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1946 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1982 + addition) / exportWidth);
        image5.setTop(1072 / exportHeight);
        image5.setWidth(((2851 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1946 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((148 + addition) / exportWidth);
        image6.setTop(1995 / exportHeight);
        image6.setWidth(((1474 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2849 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1522 + addition) / exportWidth);
        image7.setTop(1995 / exportHeight);
        image7.setWidth(((2847 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2849 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    bs_702({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1474 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1024 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1522 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2845 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1024 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1072 / exportHeight);
        image3.setWidth(((1018 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1946 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1066 + addition) / exportWidth);
        image4.setTop(1072 / exportHeight);
        image4.setWidth(((1934 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1946 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1981 + addition) / exportWidth);
        image5.setTop(1072 / exportHeight);
        image5.setWidth(((2849 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1946 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1994 / exportHeight);
        image6.setWidth(((1474 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2849 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1522 + addition) / exportWidth);
        image7.setTop(1994 / exportHeight);
        image7.setWidth(((2845 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2849 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    bs_703({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1018 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1024 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1066 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2845 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1024 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1072 / exportHeight);
        image3.setWidth(((1018 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1946 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1066 + addition) / exportWidth);
        image4.setTop(1072 / exportHeight);
        image4.setWidth(((1934 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1946 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1981 + addition) / exportWidth);
        image5.setTop(1072 / exportHeight);
        image5.setWidth(((2849 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1946 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((150 + addition) / exportWidth);
        image6.setTop(1994 / exportHeight);
        image6.setWidth(((1018 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2849 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1066 + addition) / exportWidth);
        image7.setTop(1994 / exportHeight);
        image7.setWidth(((2845 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2849 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    bs_704({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((150 + addition) / exportWidth);
        image1.setTop(150 / exportHeight);
        image1.setWidth(((1113 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((1141 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1161 + addition) / exportWidth);
        image2.setTop(150 / exportHeight);
        image2.setWidth(((2849 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((1141 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((150 + addition) / exportWidth);
        image3.setTop(1189 / exportHeight);
        image3.setWidth(((1476 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((2123 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1524 + addition) / exportWidth);
        image4.setTop(1189 / exportHeight);
        image4.setWidth(((2849 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2123 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((150 + addition) / exportWidth);
        image5.setTop(2171 / exportHeight);
        image5.setWidth(((981 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2849 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((1029 + addition) / exportWidth);
        image6.setTop(2171 / exportHeight);
        image6.setWidth(((1915 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2849 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1963 + addition) / exportWidth);
        image7.setTop(2171 / exportHeight);
        image7.setWidth(((2849 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2849 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    bs_705({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((315 + addition) / exportWidth);
        image1.setTop(213 / exportHeight);
        image1.setWidth(((1065 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((963 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1935 + addition) / exportWidth);
        image2.setTop(213 / exportHeight);
        image2.setWidth(((2684 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((963 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((315 + addition) / exportWidth);
        image3.setTop(1125 / exportHeight);
        image3.setWidth(((1065 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((1875 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((1125 + addition) / exportWidth);
        image4.setTop(1125 / exportHeight);
        image4.setWidth(((1875 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1875 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1935 + addition) / exportWidth);
        image5.setTop(1125 / exportHeight);
        image5.setWidth(((2684 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1875 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((315 + addition) / exportWidth);
        image6.setTop(2036 / exportHeight);
        image6.setWidth(((1065 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((2786 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1935 + addition) / exportWidth);
        image7.setTop(2036 / exportHeight);
        image7.setWidth(((2684 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((2786 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        return collageInfoList;

    },
    bs_801({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((923 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((856 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((977 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((1961 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((856 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2015 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3000 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((856 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(910 / exportHeight);
        image4.setWidth(((1473 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((2090 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1526 + addition) / exportWidth);
        image5.setTop(910 / exportHeight);
        image5.setWidth(((3000 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((2090 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(2143 / exportHeight);
        image6.setWidth(((923 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((977 + addition) / exportWidth);
        image7.setTop(2143 / exportHeight);
        image7.setWidth(((1961 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((2015 + addition) / exportWidth);
        image8.setTop(2143 / exportHeight);
        image8.setWidth(((3000 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    bs_802({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((964 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((964 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((1018 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((1982 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((964 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2035 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3000 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((964 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1018 / exportHeight);
        image4.setWidth(((964 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1983 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((2035 + addition) / exportWidth);
        image5.setTop(1018 / exportHeight);
        image5.setWidth(((3000 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1983 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((0 + addition) / exportWidth);
        image6.setTop(2036 / exportHeight);
        image6.setWidth(((964 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((3000 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((1018 + addition) / exportWidth);
        image7.setTop(2036 / exportHeight);
        image7.setWidth(((1982 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((2035 + addition) / exportWidth);
        image8.setTop(2036 / exportHeight);
        image8.setWidth(((3000 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        return collageInfoList;

    },
    bs_902({ exportWidth = 0, exportHeight = 0, isRightPage = false } = {}) {

        const addition = isRightPage ? 3000 : 0;
        const collageInfoList = [];
        const image1 = new CollageInfo();
        image1.setIsRight(isRightPage);
        image1.setLeft((0 + addition) / exportWidth);
        image1.setTop(0 / exportHeight);
        image1.setWidth(((642 + addition) / exportWidth) - image1.getLeft());
        image1.setHeight((964 / exportHeight) - image1.getTop());
        collageInfoList.push(image1);

        const image2 = new CollageInfo();
        image2.setIsRight(isRightPage);
        image2.setLeft((695 + addition) / exportWidth);
        image2.setTop(0 / exportHeight);
        image2.setWidth(((2249 + addition) / exportWidth) - image2.getLeft());
        image2.setHeight((964 / exportHeight) - image2.getTop());
        collageInfoList.push(image2);

        const image3 = new CollageInfo();
        image3.setIsRight(isRightPage);
        image3.setLeft((2303 + addition) / exportWidth);
        image3.setTop(0 / exportHeight);
        image3.setWidth(((3000 + addition) / exportWidth) - image3.getLeft());
        image3.setHeight((964 / exportHeight) - image3.getTop());
        collageInfoList.push(image3);

        const image4 = new CollageInfo();
        image4.setIsRight(isRightPage);
        image4.setLeft((0 + addition) / exportWidth);
        image4.setTop(1018 / exportHeight);
        image4.setWidth(((963 + addition) / exportWidth) - image4.getLeft());
        image4.setHeight((1982 / exportHeight) - image4.getTop());
        collageInfoList.push(image4);

        const image5 = new CollageInfo();
        image5.setIsRight(isRightPage);
        image5.setLeft((1017 + addition) / exportWidth);
        image5.setTop(1018 / exportHeight);
        image5.setWidth(((1981 + addition) / exportWidth) - image5.getLeft());
        image5.setHeight((1982 / exportHeight) - image5.getTop());
        collageInfoList.push(image5);

        const image6 = new CollageInfo();
        image6.setIsRight(isRightPage);
        image6.setLeft((2035 + addition) / exportWidth);
        image6.setTop(1018 / exportHeight);
        image6.setWidth(((3000 + addition) / exportWidth) - image6.getLeft());
        image6.setHeight((1982 / exportHeight) - image6.getTop());
        collageInfoList.push(image6);

        const image7 = new CollageInfo();
        image7.setIsRight(isRightPage);
        image7.setLeft((0 + addition) / exportWidth);
        image7.setTop(2035 / exportHeight);
        image7.setWidth(((642 + addition) / exportWidth) - image7.getLeft());
        image7.setHeight((3000 / exportHeight) - image7.getTop());
        collageInfoList.push(image7);

        const image8 = new CollageInfo();
        image8.setIsRight(isRightPage);
        image8.setLeft((695 + addition) / exportWidth);
        image8.setTop(2035 / exportHeight);
        image8.setWidth(((2249 + addition) / exportWidth) - image8.getLeft());
        image8.setHeight((3000 / exportHeight) - image8.getTop());
        collageInfoList.push(image8);

        const image9 = new CollageInfo();
        image9.setIsRight(isRightPage);
        image9.setLeft((2303 + addition) / exportWidth);
        image9.setTop(2035 / exportHeight);
        image9.setWidth(((3000 + addition) / exportWidth) - image9.getLeft());
        image9.setHeight((3000 / exportHeight) - image9.getTop());
        collageInfoList.push(image9);

        return collageInfoList;

    },
};

// Total methods: 477
export default LayoutMethods;
